var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __reflectGet = Reflect.get;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __superGet = (cls, obj, key) => __reflectGet(__getProtoOf(cls), key, obj);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/endpoints/base.ts
import { addMinutes } from "date-fns";
import format from "date-fns/format";

// src/utils/log.ts
var lastToken = "";
function logHttpie(endpointUrl, request, logHeadersOriginal) {
  const logHeaders = __spreadValues({}, logHeadersOriginal);
  if (logHeaders["Authorization"]) {
    if (lastToken !== logHeaders["Authorization"]) {
      lastToken = logHeaders["Authorization"];
      console.log(`LAST_AUTH_TOKEN='${lastToken}'`);
    }
    logHeaders["Authorization"] = "$LAST_AUTH_TOKEN";
  }
  console.log(
    `
# Run inside api-client: ${request.method} ${endpointUrl}
http ${request.method} ${endpointUrl} ${Object.entries(logHeaders).map(([key, val]) => `"${key}:${val}"`).join(" ")} ${typeof request.body !== "undefined" ? Object.entries(JSON.parse(request.body)).map(
      ([key, val]) => typeof val === "string" ? `${key}="${val}"` : `${key}:='${JSON.stringify(val)}'`
    ).join(" ") : ""}
`
  );
}

// src/endpoints/response/ApiClientError.ts
var ApiClientError = class _ApiClientError extends Error {
  constructor(m) {
    super(m);
    Object.setPrototypeOf(this, _ApiClientError.prototype);
    this.constructor = _ApiClientError;
    this.message = m;
  }
  getHumanError() {
    if (this.response) {
      if (this.response.result && this.response.result.errors) {
        return Object.keys(this.response.result.errors).map((k) => {
          var _a, _b;
          return (_b = (_a = this.response.result) == null ? void 0 : _a.errors) == null ? void 0 : _b[k];
        }).join("\n");
      } else if (this.response.originalBody) {
        return this.response.originalBody;
      }
    }
    return `Unknown error`;
  }
};

// src/endpoints/response/response_with_status.ts
var ResponseWithStatus = class _ResponseWithStatus {
  constructor(status, result, originalBody = "") {
    this.authError = status === 401 || status === 403;
    this.error = this.authError || status >= 400;
    this.ok = !this.error;
    this.result = result;
    this.status = status;
    this.originalBody = originalBody;
  }
  static Create(status, body) {
    let result = null;
    let originalBody = null;
    try {
      result = JSON.parse(body);
    } catch (_) {
      result = null;
      originalBody = body;
    }
    return new _ResponseWithStatus(status, result, originalBody);
  }
  static CreateFromResult(result, status = 200) {
    return new _ResponseWithStatus(status, result);
  }
};

// src/endpoints/base.ts
var CORE_PATH_URLS = [
  // /v{:digit}+/ ie. /v1/divisions
  /^\/v(\d)+\//
];
function isCoreUrl(pathname) {
  return CORE_PATH_URLS.findIndex(
    (x) => typeof x === "string" ? pathname.startsWith(x) : x.test(pathname)
  ) > -1;
}
var isTacticApiProxyEnabled = () => {
  return typeof window !== "undefined" && "__tacticApiProxy__" in window;
};
var _BaseEndpoints = class _BaseEndpoints {
  constructor(settings, organizationSlug, isIntegrations = false, id = "") {
    this.id = "base";
    this.pendingRequests = {};
    this.settings = settings;
    this.organizationSlug = organizationSlug;
    this.isIntegrations = isIntegrations;
    this.id = id;
    if (settings.legacyAuth && !settings.urlCore) {
      throw new Error("If legacyAuth is used, urlCore should be defined");
    }
  }
  getSlug() {
    return this.organizationSlug;
  }
  getBaseUrl() {
    return this.settings.url;
  }
  getAccessToken() {
    var _a, _b, _c;
    return (_c = (_b = (_a = this.settings) == null ? void 0 : _a.legacyAuth) == null ? void 0 : _b.access) != null ? _c : null;
  }
  createPeriod(start, duration, time_zone) {
    const startDate = new Date(start);
    const endDate = addMinutes(startDate, duration);
    const period = {
      start: this.createDateTimeWithTimeZone(startDate),
      end: this.createDateTimeWithTimeZone(endDate),
      time_zone
    };
    return period;
  }
  createDateTimeWithTimeZone(date) {
    return `${format(date, _BaseEndpoints.DATE_FORMAT)}T${format(date, _BaseEndpoints.TIME_FORMAT)}.000Z`;
  }
  formatGenericParams(params = {}) {
    const urlParams = new URLSearchParams();
    for (const [key, val] of Object.entries(params)) {
      if (Array.isArray(val)) {
        val.forEach((x) => {
          urlParams.append(key, x.toString());
        });
      } else if (typeof val === "boolean" && val) {
        urlParams.append(key, "");
      } else if (val) {
        urlParams.set(key, val.toString());
      }
    }
    return urlParams;
  }
  addGenericParamsToUrl(url, params = {}) {
    const formatted = this.formatGenericParams(params);
    const urlParams = formatted.toString();
    if (urlParams.toString() !== "") {
      return `${url}?${urlParams}`;
    }
    return url;
  }
  requestWithStatus(_0, _1) {
    return __async(this, arguments, function* (method, url, body = null, customSettings = {}) {
      if (isTacticApiProxyEnabled()) {
        return new Promise((resolve, reject) => {
          const requestId = `req_${Date.now()}_${Math.random()}`;
          if (!window.__tacticPendingRequests__) {
            window.__tacticPendingRequests__ = {};
          }
          window.__tacticPendingRequests__[requestId] = {
            resolve: (data) => {
              resolve(data);
              window.__tacticPendingRequests__[requestId] = null;
              delete window.__tacticPendingRequests__[requestId];
            },
            reject: (data) => {
              reject(data);
              window.__tacticPendingRequests__[requestId] = null;
              delete window.__tacticPendingRequests__[requestId];
            }
          };
          window.__tacticApiProxy__({
            requestId,
            method,
            url,
            body,
            api: this.id
          });
        });
      }
      const _a = customSettings, { legacyAuth } = _a, rest = __objRest(_a, ["legacyAuth"]);
      const settings = __spreadValues(__spreadValues({}, this.settings), rest);
      if (legacyAuth) {
        settings.legacyAuth = __spreadValues(__spreadValues({}, settings.legacyAuth), legacyAuth);
      }
      const headers = {
        "Content-Type": "application/json"
      };
      if (this.organizationSlug !== null) {
        headers["X-Tactic-Orgz"] = this.organizationSlug;
      }
      if (settings.corsBypass) {
        headers["X-Tactic-Cors-Bypass"] = settings.corsBypass;
      }
      if (settings.legacyAuth) {
        headers["Authorization"] = `Bearer ${settings.legacyAuth.access}`;
        if (settings.legacyAuth.impersonation !== null) {
          headers["X-Tactic-Impersonation"] = settings.legacyAuth.impersonation;
        }
      }
      if (settings.adminAuth) {
        if (settings.adminAuth.organizationId) {
          headers["X-Tactic-Organization-Id"] = settings.adminAuth.organizationId;
        }
        if (settings.adminAuth.userEmail) {
          headers["X-Tactic-User-Email"] = settings.adminAuth.userEmail;
        }
        if (settings.adminAuth.userId) {
          headers["X-Tactic-User-Id"] = settings.adminAuth.userId;
        }
      }
      if (settings.authHeader) {
        headers["Authorization"] = settings.authHeader;
      }
      const request = {
        headers,
        method,
        credentials: "include"
      };
      if (body !== null) {
        request.body = typeof body !== "string" ? JSON.stringify(body) : body;
      }
      const endpointUrl = this.buildUrl(url, settings);
      const log = settings.debug && (method !== "GET" || settings.debugGet);
      let logHeaders = {};
      if (settings.debugAuth) {
        logHeaders = request.headers;
      }
      if (log) {
        if (settings.debugOutput === "httpie") {
          logHttpie(endpointUrl, request, logHeaders);
        } else {
          console.log(`${request.method} ${endpointUrl} request:`, {
            headers: logHeaders,
            body: typeof request.body !== "undefined" ? request.body : null
          });
        }
      }
      let response;
      let responseWithStatus;
      try {
        response = yield fetch(endpointUrl, request);
        responseWithStatus = ResponseWithStatus.Create(
          response.status,
          yield response.text()
        );
        if (!response.ok && !settings.notThrowWithInvalidResponses) {
          if (settings.onError !== void 0 && settings.onError !== null && settings.onError) {
            settings.onError(
              response.statusText,
              response.status,
              responseWithStatus
            );
          }
          const error = new ApiClientError(response.statusText);
          error.response = responseWithStatus;
          throw error;
        }
      } catch (error) {
        if (log) {
          console.error(`${request.method} ${endpointUrl} error:`, error);
        }
        if (
          // we don't want to send the error to the handler again
          !(error instanceof ApiClientError) && settings.onError !== void 0 && settings.onError !== null && settings.onError
        ) {
          settings.onError(error);
        }
        throw error;
      }
      return responseWithStatus;
    });
  }
  request(method, url, body = null, withStatus) {
    return __async(this, null, function* () {
      const response = yield this.requestWithStatus(
        method,
        url,
        body
      );
      return withStatus ? { status: response.status, json: response.result } : response.result;
    });
  }
  buildUrl(url, settings) {
    if (settings.legacyAuth || settings.adminAuth) {
      const base = isCoreUrl(url) ? settings.urlCore : settings.url;
      return `${base}${url}`;
    }
    if (this.isIntegrations) {
      return `${settings.url}/api/integrations${url}`;
    }
    return `${settings.url}/api${url}`;
  }
};
_BaseEndpoints.MAXIMUM_LIMIT = 2e3;
_BaseEndpoints.DATE_FORMAT = "yyyy-MM-dd";
_BaseEndpoints.TIME_FORMAT = "HH:mm:ss";
var BaseEndpoints = _BaseEndpoints;
var BasePublicEndpoints = class extends BaseEndpoints {
  constructor(settings) {
    super(settings, null, void 0, "public");
  }
};
var BaseUserEndpoints = class extends BaseEndpoints {
  constructor(settings) {
    super(settings, null, void 0, "users");
  }
};
var BaseSettingsEndpoints = class extends BaseEndpoints {
  constructor(settings, organizationSlug) {
    super(settings, organizationSlug, void 0, "settings");
  }
  get(url) {
    return this.requestWithStatus("GET", url);
  }
  update(url, body) {
    return this.requestWithStatus("PUT", url, body);
  }
  delete(url) {
    return this.requestWithStatus("DELETE", url);
  }
};
var BaseOrganizationEndpoints = class _BaseOrganizationEndpoints extends BaseEndpoints {
  constructor(settings, organizationSlug) {
    super(settings, organizationSlug, void 0, "organizations");
  }
  formatTree(tree, formatter) {
    const elements = [];
    for (const node of tree) {
      const children = [];
      if (node.children.length > 0) {
        for (const innerNode of node.children) {
          if (innerNode.children.length == 0) {
            children.push(formatter(innerNode, null));
          }
        }
      }
      if (children.length > 0) {
        elements.push(formatter(node, children));
      } else {
        elements.push(formatter(node, null));
      }
    }
    return elements;
  }
  getUrl(url) {
    const organizationSlug = this.getSlug();
    let domain = this.settings.domain;
    if (domain.startsWith("https://")) {
      domain = this.settings.domain.slice(8, domain.length);
    }
    return `${this.settings.protocol}://${organizationSlug}.${domain}/${url}`;
  }
  paginatedEndpointUrl(url, pagination) {
    if (!pagination) {
      return url;
    }
    return url + (url.indexOf("?") >= 0 ? "&" : "?") + "limit=" + (pagination.limit ? pagination.limit : _BaseOrganizationEndpoints.MAXIMUM_LIMIT) + (pagination.cursor !== null ? `&cursor=${encodeURIComponent(pagination.cursor)}` : "");
  }
};
var BaseIntegrationEndpoints = class extends BaseEndpoints {
  constructor(settings, organizationSlug) {
    super(settings, organizationSlug, true, "integrations");
  }
};
var BaseExternalsEndpoints = class extends BaseEndpoints {
  constructor(settings, organizationSlug) {
    super(settings, organizationSlug, false, "externals");
  }
};

// src/endpoints/activity.ts
var ACTIVITY_ENTITIES = [
  "resource",
  "schedule",
  "wifi_connection",
  "work_policy_use"
];
var ACTIVITY_ENTITIES_ACTIONS = {
  resource: ["add", "update"],
  schedule: ["add", "update"],
  wifi_connection: [
    "add",
    "delete",
    "update",
    "ping",
    "ping:session:add"
  ],
  work_policy_use: [
    "add",
    "delete",
    "respond:rejected",
    "respond:accepted"
  ]
};
var ActivityClient = class extends BaseOrganizationEndpoints {
  log(params) {
    return __async(this, null, function* () {
      const formatted = this.formatGenericParams(params);
      return this.requestWithStatus(
        "GET",
        `/actions?${formatted.toString()}`
      );
    });
  }
};

// src/endpoints/application.ts
var Application = class extends BaseOrganizationEndpoints {
  create(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        "/applications",
        body
      );
    });
  }
  update(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/applications/${id}`,
        body
      );
    });
  }
  delete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/applications/${id}`
      );
    });
  }
  get(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/applications/${id}`
      );
    });
  }
  all() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        "/applications"
      );
    });
  }
};

// src/types/core-integration-types/avigilon.types.ts
var AVIGILON_REGIONS = /* @__PURE__ */ ((AVIGILON_REGIONS2) => {
  AVIGILON_REGIONS2["US"] = "us";
  AVIGILON_REGIONS2["EU"] = "eu";
  return AVIGILON_REGIONS2;
})(AVIGILON_REGIONS || {});

// src/types/core-integration-types/core-integration.types.ts
var CoreIntegrationTypes = /* @__PURE__ */ ((CoreIntegrationTypes2) => {
  CoreIntegrationTypes2["avigilon"] = "avigilon";
  CoreIntegrationTypes2["microsoft"] = "microsoft";
  CoreIntegrationTypes2["google"] = "google";
  return CoreIntegrationTypes2;
})(CoreIntegrationTypes || {});

// src/endpoints/core-integrations.ts
var CORE_INTEGRATIONS_BASE_PATH = "/v1/integrations";
var CoreIntegrations = class extends BaseOrganizationEndpoints {
  create(type, payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `${CORE_INTEGRATIONS_BASE_PATH}/${type}`,
        payload
      );
    });
  }
  delete(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `${CORE_INTEGRATIONS_BASE_PATH}/${id}`
      );
    });
  }
  fetch(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `${CORE_INTEGRATIONS_BASE_PATH}/${id}`
      );
    });
  }
  update(id, payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `${CORE_INTEGRATIONS_BASE_PATH}/${id}`,
        payload
      );
    });
  }
  all() {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        CORE_INTEGRATIONS_BASE_PATH
      );
    });
  }
  isInstalled(type) {
    return __async(this, null, function* () {
      try {
        const allResponse = yield this.all();
        const { ok, result } = allResponse;
        if (!ok || !result) {
          return createErrorResult(
            "Error fetching all integrations",
            allResponse
          );
        }
        const integration = result.integrations.find((i) => i.type === type);
        if (!integration) {
          return createNotInstalledResult(type);
        }
        try {
          const fullIntegrationResponse = yield this.fetch(integration.id);
          if (!fullIntegrationResponse.ok) {
            return createErrorResult(
              "Error fetching full integration details",
              fullIntegrationResponse
            );
          }
          return {
            ok: true,
            isInstalled: true,
            fullIntegration: fullIntegrationResponse.result,
            id: integration.id
          };
        } catch (fetchError) {
          return createErrorResult(
            "Error fetching full integration details",
            fetchError
          );
        }
      } catch (allError) {
        return createErrorResult("Error fetching all integrations", allError);
      }
    });
  }
};
function createNotInstalledResult(type) {
  console.warn(`Integration not found: ${type}`);
  return {
    ok: true,
    isInstalled: false,
    fullIntegration: null,
    id: null
  };
}
function createErrorResult(message, error) {
  console.error(message, error);
  return {
    ok: false,
    isInstalled: false,
    fullIntegration: null,
    id: null
  };
}

// src/endpoints/avigilon.ts
var AVIGILON_ENTRIES_URL = "/v1/integrations/avigilon/entries";
var AvigilonClient = class _AvigilonClient extends CoreIntegrations {
  createAvigilonIntegration(payload) {
    return __async(this, null, function* () {
      return __superGet(_AvigilonClient.prototype, this, "create").call(this, "avigilon" /* avigilon */, payload);
    });
  }
  delete(id) {
    return __async(this, null, function* () {
      return __superGet(_AvigilonClient.prototype, this, "delete").call(this, id);
    });
  }
  updateAvigilonIntegration(id, payload) {
    return __async(this, null, function* () {
      return __superGet(_AvigilonClient.prototype, this, "update").call(this, id, payload);
    });
  }
  fetchAvigilonIntegration(id) {
    return __async(this, null, function* () {
      return __superGet(_AvigilonClient.prototype, this, "fetch").call(this, id);
    });
  }
  fetchOrganizations() {
    return __async(this, null, function* () {
      let res = null;
      try {
        res = __superGet(_AvigilonClient.prototype, this, "requestWithStatus").call(
          this,
          "GET",
          `${CORE_INTEGRATIONS_BASE_PATH}/avigilon/organizations`
        );
      } catch (e) {
        console.error(e);
        throw e;
      }
      return res;
    });
  }
  integrationIsInstalled() {
    return __async(this, null, function* () {
      return __superGet(_AvigilonClient.prototype, this, "isInstalled").call(
        this,
        "avigilon" /* avigilon */
      );
    });
  }
  fetchAvigilonExternalIds() {
    return __async(this, null, function* () {
      return __superGet(_AvigilonClient.prototype, this, "requestWithStatus").call(
        this,
        "GET",
        AVIGILON_ENTRIES_URL
      );
    });
  }
};

// src/endpoints/calendar.ts
var Calendar = class extends BaseOrganizationEndpoints {
  getOrganizationCalendar(authorization, organizationId, id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/organizations/${organizationId}/calendars/${id}`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  getCalendar(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus("GET", `/calendars/${id}`);
    });
  }
  getAuthorizationUrl(source, organizationId) {
    return `https://id.gettactic.com/enterprise/calendar/setup/${source}/${organizationId}`;
  }
  hasAuthorization(source) {
    return __async(this, null, function* () {
      const response = yield this.requestWithStatus(
        "GET",
        `/calendars/authorizations/has_valid?calendarSource=${source}`
      );
      return response.ok && response.result.has_authorization;
    });
  }
  getCalendarByResourceId(resourceId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/calendars/reference/${resourceId}`
      );
    });
  }
  fetchCalendarPending(authorization) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/calendars/pending`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  markCalendarProcessed(authorization, jobId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/calendars/pending/${jobId}`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  all(_0, _1, _2, _3) {
    return __async(this, arguments, function* (sources, types, integrationIds, includeAllResources, pagination = {
      cursor: null,
      limit: null
    }) {
      let url = "/calendars";
      const params = new URLSearchParams();
      if (sources !== null) {
        sources.forEach((e) => {
          params.append("calendarSource", e);
        });
      }
      if (types !== null) {
        types.forEach((e) => {
          params.append("calendarType", e);
        });
      }
      if (integrationIds !== null) {
        integrationIds.forEach((e) => {
          params.append("integrationId", e);
        });
      }
      if (includeAllResources) {
        params.append("include-all-resources", String(includeAllResources));
      }
      if (params.size > 0) {
        url += `?${params.toString()}`;
      }
      return this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl(url, pagination)
      );
    });
  }
  allSyncJobs(_0) {
    return __async(this, arguments, function* (calendarId, pagination = {
      cursor: null,
      limit: null
    }) {
      const url = `/calendars/${calendarId}/sync_jobs`;
      return this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl(url, pagination)
      );
    });
  }
  allForSync(authorization, organizationId, integrationIds, sources = null, types = null) {
    return __async(this, null, function* () {
      if (integrationIds.length === 0) {
        throw new Error("Missing integration IDs");
      }
      let url = `/calendars/${organizationId}/for_sync`;
      const params = new URLSearchParams();
      integrationIds.forEach((e) => {
        params.append("integrationId", e);
      });
      if (sources !== null) {
        sources.forEach((e) => {
          params.append("calendarSource", e);
        });
      }
      if (types !== null) {
        types.forEach((e) => {
          params.append("calendarType", e);
        });
      }
      url += `?${params.toString()}`;
      return this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl(url, {
          cursor: null,
          limit: `${integrationIds.length}`
        }),
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  createOrUpdateCalendar(id, body, slug = null) {
    return __async(this, null, function* () {
      const basePath = "/v1/calendars";
      return this.requestWithStatus(
        id !== null ? "PUT" : "POST",
        id !== null ? `${basePath}/${id}` : basePath,
        body
      );
    });
  }
  deauthorizeIntegration(integrationType) {
    return __async(this, null, function* () {
      if (integrationType !== "microsoft" /* microsoft */ && integrationType !== "google" /* google */) {
        throw new Error("Invalid integration type");
      }
      return this.requestWithStatus(
        "DELETE",
        `/v1/calendars/authorization/${integrationType}`
      );
    });
  }
  /**
   * @deprecated  Use createOrUpdateCalendar(body: CalendarCreateOrUpdateRequest)
   */
  createOrUpdate(organizationId, organizationSlug, source, type, referenceId, integrationId, isEnabled, isPullEnabled, isPushEnabled, id = null) {
    return this.createOrUpdateCalendar(id, {
      organization_id: organizationId,
      source,
      type,
      reference_id: referenceId,
      integration_id: integrationId,
      is_enabled: isEnabled,
      is_pull_enabled: isPullEnabled,
      is_push_enabled: isPushEnabled,
      sync_events: true,
      sync_leaves: false
    }, organizationSlug);
  }
  sync(authorization, organizationId, calendarId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        calendarId !== null ? `/organizations/${organizationId}/calendars/${calendarId}/sync` : `/organizations/${organizationId}/calendars/sync`,
        body,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  syncEventRequest(authorization, calendarId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/calendars/${calendarId}/events/requests/sync`,
        body,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  syncEventRequestGetForSyncing(authorization, organizationId = null) {
    return __async(this, null, function* () {
      const url = organizationId !== null ? `/calendars/events/requests/for_syncing?organization=${encodeURIComponent(organizationId)}` : `/calendars/events/requests/for_syncing`;
      return this.requestWithStatus("PUT", url, null, {
        authHeader: `Basic ${authorization}`
      });
    });
  }
  syncEvent(authorization, calendarId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/calendars/${calendarId}/events/sync`,
        body,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  syncEventCreation(authorization, calendarId, scheduleId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/calendars/${calendarId}/events/sync/schedules/${scheduleId}`,
        body,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  syncEventDeletion(authorization, calendarId, eventId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/calendars/${calendarId}/events/sync`,
        {
          event_id: eventId
        },
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  transform(authorization, organizationId, scheduleId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/calendars/${organizationId}/schedules/${scheduleId}/transform`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  fetchPending(authorization) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/calendars/schedules/updated/pending`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  markProcessed(authorization, organizationId, jobId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/calendars/${organizationId}/schedules/updated/${jobId}`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  syncLeave(authorization, calendarId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/calendars/${calendarId}/leave/sync`,
        body,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  createOrUpdateSyncJob(authorization, organizationId, calendarId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/${calendarId}/sync_jobs`,
        body,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  getSyncJobForSyncing(authorization, organizationId = null, calendarId = null, jobId = null, sources = null, types = null) {
    return __async(this, null, function* () {
      let url = organizationId !== null && calendarId !== null && jobId !== null ? `/organizations/${organizationId}/calendars/${calendarId}/sync_jobs/${jobId}/for_syncing` : organizationId !== null && calendarId !== null ? `/organizations/${organizationId}/calendars/${calendarId}/sync_jobs/for_syncing` : organizationId !== null ? `/organizations/${organizationId}/calendars/sync_jobs/for_syncing` : `/organizations/calendars/sync_jobs/for_syncing`;
      const params = new URLSearchParams();
      if (sources !== null) {
        sources.forEach((e) => {
          params.append("calendarSource", e);
        });
      }
      if (types !== null) {
        types.forEach((e) => {
          params.append("calendarType", e);
        });
      }
      url += `?${params.toString()}`;
      return this.requestWithStatus("PUT", url, null, {
        authHeader: `Basic ${authorization}`
      });
    });
  }
  markSyncJobAsSynced(authorization, organizationId, calendarId, jobId, syncToken, pageToken) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/${calendarId}/sync_jobs/${jobId}/synced`,
        { sync_token: syncToken, page_token: pageToken },
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markSyncJobAsFinished(authorization, organizationId, calendarId, jobId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/${calendarId}/sync_jobs/${jobId}/finished`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markSyncJobAsFailed(authorization, organizationId, calendarId, jobId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/${calendarId}/sync_jobs/${jobId}/failed`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  createOrUpdateAuthorization(authorization, organizationId, request) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/authorizations`,
        request,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  getAuthorizationForSyncing(authorization, organizationId, calendarSource, authorizationId = null) {
    return __async(this, null, function* () {
      const url = authorizationId !== null ? `/organizations/${organizationId}/calendars/authorizations/${authorizationId}/for_syncing?calendarSource=${encodeURIComponent(calendarSource)}` : `/organizations/${organizationId}/calendars/authorizations/for_syncing?calendarSource=${encodeURIComponent(calendarSource)}`;
      return this.requestWithStatus(
        "PUT",
        url,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markAuthorizationAsSynced(authorization, organizationId, authorizationId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/authorizations/${authorizationId}/synced`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markAuthorizationAsFailed(authorization, organizationId, authorizationId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/authorizations/${authorizationId}/failed`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  createOrUpdateAuthorizationIntent(authorization, organizationId, request) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/authorizations/intents`,
        request,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  getAuthorizationIntentForSyncing(authorization, organizationId, calendarSource) {
    return __async(this, null, function* () {
      let url = `/calendars/authorizations/intents/for_syncing?calendarSource=${encodeURIComponent(calendarSource)}`;
      if (organizationId !== null) {
        url += `&organization=${encodeURIComponent(organizationId)}`;
      }
      return this.requestWithStatus(
        "PUT",
        url,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markAuthorizationIntentAsChecked(authorization, organizationId, intentId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/authorizations/intents/${intentId}/checked`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  getListenerListening(authorization, organizationId, id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/organizations/${organizationId}/calendars/${id}/listeners/listening`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  createOrUpdateListener(authorization, organizationId, id, body, listenerId = null) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        listenerId !== null ? "PUT" : "POST",
        listenerId !== null ? `/organizations/${organizationId}/calendars/${id}/listeners/${listenerId}` : `/organizations/${organizationId}/calendars/${id}/listeners`,
        body,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markListenerAsStarted(authorization, organizationId, listenerId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/listeners/${listenerId}/started`,
        body,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markListenerAsStopped(authorization, organizationId, listenerId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/listeners/${listenerId}/stopped`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  listenerNotified(authorization, organizationId, listenerId, token) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/listeners/${listenerId}/notified`,
        { token },
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  getForSyncCheck(authorization, organizationId = null, sources = null, types = null) {
    return __async(this, null, function* () {
      let url = organizationId !== null ? `/organizations/${organizationId}/calendars/for_sync_check` : `/calendars/for_sync_check`;
      const params = new URLSearchParams();
      if (sources !== null) {
        sources.forEach((e) => {
          params.append("calendarSource", e);
        });
      }
      if (types !== null) {
        types.forEach((e) => {
          params.append("calendarType", e);
        });
      }
      url += `?${params.toString()}`;
      return this.requestWithStatus("GET", url, null, {
        authHeader: `Basic ${authorization}`
      });
    });
  }
  markAsSyncChecked(authorization, organizationId, calendarId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/${calendarId}/sync_checked`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
};

// src/endpoints/divisions.ts
var BASE_PATH = "/v1/divisions";
var DivisionsClient = class extends BaseOrganizationEndpoints {
  create(payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", BASE_PATH, payload);
    });
  }
  delete(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus("DELETE", `${BASE_PATH}/${id}`);
    });
  }
  update(payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `${BASE_PATH}/${payload.id}`,
        payload
      );
    });
  }
  all(params) {
    return __async(this, null, function* () {
      const urlParams = this.formatGenericParams(params);
      return this.requestWithStatus(
        "GET",
        `${BASE_PATH}?${urlParams.toString()}`
      );
    });
  }
  withOffices(params, withFloors = false) {
    return __async(this, null, function* () {
      const urlParams = this.formatGenericParams(params);
      urlParams.set("return_type", "tree");
      if (withFloors) {
        urlParams.set("return_floors", "true");
      }
      return this.requestWithStatus(
        "GET",
        `${BASE_PATH}?${urlParams.toString()}`
      );
    });
  }
};

// src/endpoints/enterprises.ts
var Enterprises = class extends BaseOrganizationEndpoints {
  domains() {
    return __async(this, null, function* () {
      const response = yield this.requestWithStatus("GET", "/enterprise");
      return response;
    });
  }
  update_domains(domains) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("PUT", "/enterprise", {
        domains
      });
    });
  }
  /**
   * Generates and returns WorkOS links for both SSO and DSync setup
   */
  links() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        "/enterprise/links"
      );
    });
  }
  connections() {
    return __async(this, arguments, function* (pagination = {
      cursor: null,
      limit: null
    }) {
      const response = yield this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl("/enterprise/connections", pagination)
      );
      return response;
    });
  }
  directories() {
    return __async(this, arguments, function* (pagination = {
      cursor: null,
      limit: null
    }) {
      const response = yield this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl("/enterprise/directories", pagination)
      );
      return response;
    });
  }
};

// src/endpoints/externals.ts
var Externals = class extends BaseExternalsEndpoints {
  getExternalIds(object_id, object_type, type) {
    return __async(this, null, function* () {
      const params = new URLSearchParams({ object_id });
      if (object_type) {
        params.set("object_type", object_type);
      }
      if (type) {
        params.set("type", type);
      }
      const result = yield this.requestWithStatus(
        "GET",
        `/v1/externals?${params.toString()}`
      );
      return result;
    });
  }
  deleteExternalId(id) {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "DELETE",
        `/v1/externals/${id}`
      );
      return result;
    });
  }
  createExternalId(data) {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "POST",
        "/v1/externals",
        data
      );
      return result;
    });
  }
};

// src/endpoints/forms.ts
var Forms = class extends BaseOrganizationEndpoints {
  add(request) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", `/forms`, request);
    });
  }
  form(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/forms/${encodeURIComponent(id)}`
      );
    });
  }
};

// src/endpoints/health.ts
var Health = class extends BaseOrganizationEndpoints {
  scanVaccination(officeId, contents) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/offices/${officeId}/vaccinations/scan`,
        {
          contents
        }
      );
    });
  }
  scanTest(officeId, contents) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/offices/${officeId}/tests/scan`,
        { contents }
      );
    });
  }
  vaccines(officeId) {
    return __async(this, null, function* () {
      return officeId ? this.requestWithStatus(
        "GET",
        `/offices/${officeId}/vaccines`
      ) : this.requestWithStatus("GET", `/vaccines`);
    });
  }
  documents(options) {
    return __async(this, null, function* () {
      const {
        cursor = null,
        search = null,
        status = null,
        type = null,
        offices = null,
        limit = 50,
        users = []
      } = options;
      const qs = new URLSearchParams();
      if (cursor) {
        qs.set("cursor", cursor);
      }
      if (status) {
        qs.set("status", status);
      }
      if (search) {
        qs.set("search", search);
      }
      if (limit) {
        qs.set("limit", limit.toString());
      }
      if (type) {
        qs.set("document", type);
      }
      if (users && users.length > 0) {
        users.forEach((p) => qs.append("user", p));
      }
      if (offices && offices.length > 0) {
        offices.forEach((p) => qs.append("office", p));
      }
      const params = qs.toString();
      return this.requestWithStatus(
        "GET",
        `/documents?${params}`
      );
    });
  }
  getTestDocuments(userId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/tests?user=${userId}`
      );
    });
  }
  getVaccinationDocuments(userId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/vaccinations?user=${userId}`
      );
    });
  }
  getTestDocument(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus("GET", `/tests/${id}`);
    });
  }
  getVaccinationDocument(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/vaccinations/${id}`
      );
    });
  }
  addVaccinationDocument(officeId, vaccine) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/offices/${officeId}/vaccinations`,
        vaccine
      );
    });
  }
  addTestDocument(officeId, test) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/offices/${officeId}/tests`,
        test
      );
    });
  }
  rejectDocument(type, doc, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/${type}/${doc.id}/respond/rejected`,
        body
      );
    });
  }
  acceptDocument(type, doc, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/${type}/${doc.id}/respond/accepted`,
        body
      );
    });
  }
  changeUserHealth(user, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/users/${user.id}/health/status`,
        body
      );
    });
  }
  changeUserGroupHealth(user, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/users/${user.id}/health/group`,
        body
      );
    });
  }
};

// src/endpoints/hours.ts
import { format as format2 } from "date-fns";
var HoursClient = class extends BaseOrganizationEndpoints {
  all(officeId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/hours`
      );
    });
  }
  rules(officeId, resourceId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/hours?type=rule${resourceId ? `&resource=${encodeURIComponent(resourceId)}` : ""}`
      );
    });
  }
  weekdays(officeId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/hours?type=weekday`
      );
    });
  }
  holidays(officeId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/hours?type=holiday`
      );
    });
  }
  create(officeId, body, params) {
    return __async(this, null, function* () {
      const url = this.addGenericParamsToUrl(
        `/offices/${encodeURIComponent(officeId)}/hours`,
        params
      );
      return this.requestWithStatus("POST", url, body);
    });
  }
  createForResource(resourceId, body, params) {
    return __async(this, null, function* () {
      const url = this.addGenericParamsToUrl(
        `/resources/${encodeURIComponent(resourceId)}/hours`,
        params
      );
      return this.requestWithStatus("POST", url, body);
    });
  }
  updateWeekdays(officeId, body) {
    return __async(this, null, function* () {
      const data = [];
      Object.keys(body).forEach((day) => {
        const dayName = day;
        data.push(__spreadProps(__spreadValues({}, body[dayName]), {
          //day: dayName,
          start_time: format2(body[dayName].start_time, "HH:mm:ss"),
          end_time: format2(body[dayName].end_time, "HH:mm:ss")
        }));
      });
      return this.requestWithStatus(
        "PUT",
        `/offices/${encodeURIComponent(officeId)}/operational`,
        {
          days: data
        }
      );
    });
  }
  delete(officeId, hourId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/offices/${encodeURIComponent(officeId)}/hours/${encodeURIComponent(hourId.toString())}`
      );
    });
  }
  put(officeId, hourId, body, params) {
    return __async(this, null, function* () {
      const url = this.addGenericParamsToUrl(
        `/offices/${encodeURIComponent(officeId)}/hours/${encodeURIComponent(hourId.toString())}`,
        params
      );
      return this.requestWithStatus("PUT", url, body);
    });
  }
  get(officeId, hourId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/hours/${encodeURIComponent(hourId.toString())}`
      );
    });
  }
};

// src/endpoints/integrations.ts
var Integrations = class extends BaseIntegrationEndpoints {
  /**
   * Get all installed integrations for the user
   */
  getInstalledIntegrations() {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "GET",
        "/api/integrations/installed"
      );
      return result;
    });
  }
  /**
   * Get all installed admin integrations for the org
   */
  getInstalledAdminIntegrations() {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "GET",
        "/api/integrations/admin-installed"
      );
      return result;
    });
  }
  /**
   * Set up a third party integration
   * @param integrationType - Type of the integration we are setting up
   * @param body - information to store for the integration
   * @param isAdmin - Whether this is an admin integration. Example is microsoft-teams org setup
   * @returns
   */
  setupIntegration(integrationType, body, isAdmin = false) {
    return __async(this, null, function* () {
      let url = `/${integrationType}/setup`;
      if (isAdmin) {
        url += "?userType=admin";
      }
      const result = yield this.requestWithStatus("POST", url, body);
      return result;
    });
  }
  /**
   * Save Integration Options
   * @param integrationType - Type of the integration we are modifying
   * @param body - information to store for the integration
   * @param isAdmin - Whether this is an admin integration. Example is google app 2 way syncing
   * @returns
   */
  saveIntegrationOptions(integrationType, body, isAdmin = false) {
    return __async(this, null, function* () {
      let url = `/api/integrations/${isAdmin ? "admin-options" : "options"}`;
      const result = yield this.requestWithStatus("POST", url, {
        integrationType,
        options: body
      });
      return result;
    });
  }
  /**
   * Deauthorize an integration
   * @param integrationType - The type of integration, e.g. google or zoom
   * @param isAdmin - Whether this is an admin integration. Example is google 2 way sync admin
   */
  deauthorizeIntegration(integrationType, isAdmin = false) {
    return __async(this, null, function* () {
      let url = `/${integrationType}/deauthorize`;
      if (isAdmin) {
        url += "?userType=admin";
      }
      const result = yield this.requestWithStatus("DELETE", url, {});
      return result;
    });
  }
  /**
   * Get all installed integration settings for the user
   */
  getInstalledIntegrationSettings() {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "GET",
        "/api/integrations/settings"
      );
      return result;
    });
  }
  /**
   * Update installed integrations settings
   * @param settingsData - integrations and their updated settings
   */
  updateInstalledIntegrationSettings(settingsData) {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "PUT",
        "/api/integrations/settings",
        settingsData
      );
      return result;
    });
  }
  /**
   * Registers a device token for push notifications
   * @param body - Request containing the device information
   * @returns
   */
  registerDevice(body) {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "POST",
        `/api/devices/register`,
        body
      );
      return result;
    });
  }
  /**
   * Syncs resources with the freshwater system
   */
  syncFreshwaterResources() {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "POST",
        "/api/freshwater/sync",
        {}
      );
      return result;
    });
  }
};

// src/endpoints/invitations.ts
var Invitations = class extends BaseOrganizationEndpoints {
  /**
   * Returns all invitations that have been sent via an organization. Use this
   * to see if invitations have been accepted, rejected, revoked, or still pending.
   * Does NOT include invitation code
   */
  all() {
    return __async(this, arguments, function* (pagination = {
      cursor: null,
      limit: null
    }) {
      const response = yield this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl("/invitations", pagination)
      );
      return response;
    });
  }
  /**
   * Returns invitation details by invitation id
   */
  getById(invitationId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/invitations/${encodeURIComponent(invitationId)}`
      );
    });
  }
  /**
   * Revoke pending invitation
   */
  delete(invitationId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/invitations/${encodeURIComponent(invitationId)}`
      );
    });
  }
  /**
   * Sends an email invitation to a user to join a specific organization.
   * Role of "member" should be set by default. Optionally add team id's to
   * auto enroll user to specified teams upon acceptance of invitation.
   */
  add(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/invitations", body);
    });
  }
};

// src/entities/leave.ts
var ALL_LEAVE_POLICY_TYPES = [
  "bereavement",
  "custom",
  "holiday",
  "office",
  "ooo",
  "parental",
  "personal",
  "remote",
  "sick",
  "unpaid",
  "vacation"
];
var LeavePolicyTypeDisplay = /* @__PURE__ */ ((LeavePolicyTypeDisplay2) => {
  LeavePolicyTypeDisplay2["bereavement"] = "Bereavement";
  LeavePolicyTypeDisplay2["custom"] = "Custom";
  LeavePolicyTypeDisplay2["holiday"] = "Holiday";
  LeavePolicyTypeDisplay2["office"] = "Office";
  LeavePolicyTypeDisplay2["ooo"] = "OOO";
  LeavePolicyTypeDisplay2["parental"] = "Parental";
  LeavePolicyTypeDisplay2["personal"] = "Personal";
  LeavePolicyTypeDisplay2["remote"] = "Remote";
  LeavePolicyTypeDisplay2["sick"] = "Sick";
  LeavePolicyTypeDisplay2["unpaid"] = "Unpaid";
  LeavePolicyTypeDisplay2["vacation"] = "Vacation";
  return LeavePolicyTypeDisplay2;
})(LeavePolicyTypeDisplay || {});

// src/endpoints/leave.ts
var LeaveClient = class extends BaseOrganizationEndpoints {
  formatParams(params = {}) {
    return this.formatGenericParams(params);
  }
  createPolicy(payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/work_policies`,
        payload
      );
    });
  }
  deletePolicy(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/work_policies/${id}`
      );
    });
  }
  updatePolicy(payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/work_policies/${payload.id}`,
        payload
      );
    });
  }
  allPolicies(params) {
    return __async(this, null, function* () {
      const urlParams = this.formatParams(params);
      return this.requestWithStatus(
        "GET",
        `/work_policies?${urlParams.toString()}`
      );
    });
  }
  applicablePolicies(workPolicyType, options) {
    return __async(this, null, function* () {
      const urlParams = this.formatParams(__spreadValues({ workPolicyType }, options));
      return this.requestWithStatus("GET", `/work_policies/applicable/?${urlParams.toString()}`);
    });
  }
  allApplicablePolicies(params) {
    return __async(this, null, function* () {
      var _a;
      const askedTypes = (_a = params.type) != null ? _a : ALL_LEAVE_POLICY_TYPES;
      const policiesRes = askedTypes.map((type) => __async(this, null, function* () {
        try {
          const res = yield this.applicablePolicies(type, params);
          return res.result;
        } catch (e) {
          if (e instanceof ApiClientError && e.response.status === 404) {
            return [];
          }
          console.error("Error while fetching applicable policies", e);
          throw e;
        }
      }));
      const policies = yield Promise.all(policiesRes);
      return policies.flat().filter((x) => !!x);
    });
  }
  createRequest(payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/work_policies/uses`,
        payload
      );
    });
  }
  allRequests(params, managed = false) {
    return __async(this, null, function* () {
      const urlParams = this.formatParams(params);
      return this.requestWithStatus(
        "GET",
        `/work_policies/uses/${managed ? "managed/" : ""}?${urlParams.toString()}`
      );
    });
  }
  leaveRequest(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/work_policies/uses/${id}`
      );
    });
  }
  respondRequests(payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/work_policies/uses/respond`,
        payload
      );
    });
  }
  deleteRequests(ids) {
    return __async(this, null, function* () {
      return Promise.all(
        ids.map(
          (id) => this.requestWithStatus(
            "DELETE",
            `/work_policies/uses/${id}`
          )
        )
      );
    });
  }
  conflicts(payload) {
    return __async(this, null, function* () {
      const urlParams = this.formatParams(payload);
      return this.requestWithStatus(
        "GET",
        `/work_policies/uses/matching?${urlParams}`
      );
    });
  }
};

// src/endpoints/organizations.ts
import * as signalR from "@microsoft/signalr";

// src/utils.ts
import { eachDayOfInterval, format as format3, parseISO } from "date-fns";
import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";
function formatOptions(actionResult) {
  let byId = {}, options = [];
  for (const element of actionResult.elements) {
    byId[element.id] = element;
    options.push({ value: element.id, label: element.name });
  }
  return __spreadProps(__spreadValues({}, actionResult), {
    byId,
    options
  });
}
function parseApiDateStr(dateStr, timeZone) {
  const parsedStr = dateStr.endsWith("Z") ? dateStr.slice(0, -1) : dateStr;
  const utcDate = zonedTimeToUtc(parseISO(parsedStr), timeZone);
  return utcToZonedTime(utcDate, timeZone);
}
function getDaysWithinTimespan(startTime, endTime, timeZone) {
  const startInTimeZone = parseApiDateStr(startTime, timeZone);
  const endInTimeZone = parseApiDateStr(endTime, timeZone);
  startInTimeZone.setHours(0, 0, 0, 0);
  if (endInTimeZone.getHours() === 0 && endInTimeZone.getMinutes() === 0 && endInTimeZone.getSeconds() === 0) {
    endInTimeZone.setDate(endInTimeZone.getDate() - 1);
  }
  endInTimeZone.setHours(0, 0, 0, 0);
  if (startInTimeZone.getTime() === endInTimeZone.getTime()) {
    return [format3(startInTimeZone, "yyyy-MM-dd")];
  }
  const days = eachDayOfInterval({
    start: startInTimeZone,
    end: endInTimeZone
  });
  const formattedDays = days.map((day) => format3(day, "yyyy-MM-dd"));
  return formattedDays;
}

// ../helpers/src/objects/objectToQueryString.ts
function objectToQueryString(params) {
  const query = Object.entries(params).filter(
    ([_, value]) => value !== void 0 && value !== null && value !== ""
  ).map(
    ([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
  ).join("&");
  return query ? `?${query}` : "";
}

// src/endpoints/organizations.ts
var Organizations = class _Organizations extends BaseOrganizationEndpoints {
  static resourceFormatter(node, formattedChildren) {
    if (formattedChildren !== null) {
      let totalAvailableSlots = 0;
      let totalInnerSlots = 0;
      let totalReservedSlots = 0;
      for (const element of formattedChildren) {
        totalAvailableSlots += element.available_slots;
        totalInnerSlots += element.total_slots;
        totalReservedSlots += element.reserved_slots;
      }
      return __spreadProps(__spreadValues({}, node.resource), {
        available_slots: totalAvailableSlots,
        reserved_slots: totalReservedSlots,
        total_slots: totalInnerSlots,
        options: formattedChildren
      });
    }
    return __spreadValues({}, node.resource);
  }
  get(slug) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/organizations/${encodeURIComponent(slug)}`
      );
    });
  }
  getById(authorization, id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/id/organizations/${id}`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  /**
   * Primary endpoint for returning the current authenticated user, within the context of the current org
   */
  getOrgMe() {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/user`
      );
    });
  }
  isDeskBookingEnabled(organization) {
    return organization.desk_bookings_enabled;
  }
  isParkingBookingEnabled(organization) {
    return organization.parking_bookings_enabled;
  }
  isMeetingRoomBookingEnabled(organization) {
    return organization.meeting_room_bookings_enabled;
  }
  /**
   * Updated the organization's logo with the provided image URL
   */
  updateIcon(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("PUT", "/organizations/logo", body);
    });
  }
  updateQuestionnaireSettings(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        "/organizations/questionnaire/settings",
        body
      );
    });
  }
  updateGeneralSettings(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        "/organizations/general/settings",
        body
      );
    });
  }
  join() {
    return __async(this, null, function* () {
      const response = yield this.requestWithStatus("GET", "/invitations/join");
      return __spreadProps(__spreadValues({}, response), {
        result: {
          enabled: response.result ? response.result.enabled : false,
          url: response.result && response.result.enabled ? this.getJoinUrl(response.result.join) : null
        }
      });
    });
  }
  joinEnable(body) {
    return __async(this, null, function* () {
      const response = yield this.requestWithStatus("PUT", "/invitations/join", body);
      return __spreadProps(__spreadValues({}, response), {
        result: {
          enabled: response.result ? response.result.enabled : false,
          url: response.result && response.result.enabled ? this.getJoinUrl(response.result.join) : null
        }
      });
    });
  }
  /**
   * Creates the authenticatedUser object for the currently
   * authenticated user.
   */
  me(user, organization, organizations, offices, designSystemVersion) {
    var _a, _b;
    const slug = this.getSlug();
    const authenticatedUser = {
      user,
      slug,
      redirect: {
        setup: false,
        login: false,
        subdomain: null,
        url: null
      },
      permissions: {
        all: [],
        impersonate: false,
        schedule_others: false,
        schedule_others_managed: false,
        schedule_respond: false,
        settings: false,
        enterprise: false
      },
      organizations: organizations ? organizations.elements : [],
      organization,
      offices: offices ? offices : null,
      officeId: offices && offices.officeId ? offices.officeId : null,
      defaultAreaId: (_b = (_a = user == null ? void 0 : user.organization_user) == null ? void 0 : _a.default_area_id) != null ? _b : null,
      designSystemVersion
    };
    const defaultOfficeNotDeleted = offices ? offices.offices.some(
      (office) => office.id === user.organization_user.default_office_id
    ) : false;
    const validDefaultOfficeId = offices && defaultOfficeNotDeleted ? user.organization_user.default_office_id : offices == null ? void 0 : offices.offices[0].id;
    if (authenticatedUser.offices) {
      authenticatedUser.offices.officeId = validDefaultOfficeId != null ? validDefaultOfficeId : null;
    }
    const permissions = user.organization_user ? user.organization_user.permissions : [];
    authenticatedUser.permissions = {
      all: permissions,
      impersonate: permissions.includes("admin:impersonate"),
      schedule_others: permissions.includes("schedule:others:add"),
      schedule_others_managed: permissions.includes(
        "schedule:others:managed:add"
      ),
      schedule_respond: permissions.includes("schedule:respond"),
      settings: permissions.includes("office:add"),
      enterprise: permissions.includes("organization:enterprise")
    };
    return authenticatedUser;
  }
  updateMe(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("PUT", "/user", body);
    });
  }
  getUserByEmail(authorization, organizationId, email) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/organizations/${organizationId}/users/${email}`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  updateUserPhoto(authorization, organizationId, userId, url) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/users/${userId}/photo`,
        {
          profile_photo_url: url
        },
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  restrictions(_0) {
    return __async(this, arguments, function* (officeId, resourceIds = [], dates, duration = null) {
      const params = new URLSearchParams();
      dates.forEach((x) => {
        params.append("date", x);
        if (duration) {
          params.append("duration", duration.toString());
        }
      });
      resourceIds.forEach((resId) => params.append("resource", resId));
      return yield this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/restrictions?${params.toString()}`
      );
    });
  }
  /**
   * Updates the user's profile image with the provided image
   */
  updatePhoto(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("PUT", "/user/logo", body);
    });
  }
  /**
   * Update a users's default office, within the context of the organization
   */
  updateDefaultOffice(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("PUT", "/user/offices/default", body);
    });
  }
  resetPassword(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("DELETE", "/user/password", body);
    });
  }
  /**
   * Update the organization's settings
   */
  update(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("PUT", "/organizations", body);
    });
  }
  usersPaginated(filters, managed = false) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/users${managed ? "/managed" : ""}?${filters.toString()}`
      );
    });
  }
  usersWithOptions(_0, _1) {
    return __async(this, arguments, function* (query, roles, pagination = {
      cursor: null,
      limit: null
    }, managed = false) {
      const res = yield this.users(query, roles, pagination, managed);
      if (res.ok && res.result) {
        const formatted = formatOptions(
          res.result
        );
        return __spreadProps(__spreadValues({}, res), { result: formatted });
      }
      return res;
    });
  }
  organizationUsers(authorization, organizationId, roles, pagination) {
    return __async(this, null, function* () {
      const params = new URLSearchParams();
      if (roles) {
        roles.forEach((role) => params.append("role", role));
      }
      const parmsString = params.toString();
      return this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl(
          `/organizations/${organizationId}/users`,
          pagination
        ) + (parmsString ? `&${parmsString}` : ""),
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  users(_0, _1) {
    return __async(this, arguments, function* (query, roles, pagination = {
      cursor: null,
      limit: null
    }, managed = false) {
      var _a, _b;
      const result = {
        letters: {},
        cursor: null,
        elements: []
      };
      const params = new URLSearchParams();
      if (query) {
        params.set("query", query);
      }
      if (roles) {
        roles.forEach((role) => params.append("role", role));
      }
      const parmsString = params.toString();
      const response = yield this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl(
          `${this.settings.adminAuth ? "/integrations" : ""}/users` + (managed ? "/managed" : ""),
          pagination
        ) + (parmsString ? `&${parmsString}` : "")
      );
      if (!response.ok) {
        return response;
      }
      result.cursor = ((_a = response.result) == null ? void 0 : _a.cursor) || null;
      result.elements = ((_b = response.result) == null ? void 0 : _b.elements) || [];
      for (const element of result.elements) {
        const name = (element.name || element.email || "").trim();
        if (name.length === 0) {
          continue;
        }
        const letter = name.slice(name.lastIndexOf(" ") + 1)[0].toUpperCase();
        if (typeof result.letters[letter] === "undefined") {
          result.letters[letter] = [];
        }
        result.letters[letter].push(element);
      }
      return __spreadProps(__spreadValues({}, response), { result });
    });
  }
  /**
   * @deprecated use teams.forUser()
   */
  userTeamList(userId, showHidden = false) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/users/${encodeURIComponent(userId)}/teams${showHidden ? "?hidden" : ""}`
      );
    });
  }
  usersById(ids) {
    return __async(this, null, function* () {
      const all = ids.map(
        (id) => this.requestWithStatus(
          "GET",
          `/users/${encodeURIComponent(id)}`
        )
      );
      const results = yield Promise.all(all);
      return results.filter((x) => x.ok).map((x) => x.result);
    });
  }
  user(id, showHidden = false) {
    return __async(this, null, function* () {
      const promises = yield Promise.all([
        this.requestWithStatus(
          "GET",
          `/users/${encodeURIComponent(id)}`
        ),
        this.requestWithStatus(
          "GET",
          `/users/${encodeURIComponent(id)}/colleagues`
        ),
        this.userTeamList(id, showHidden)
      ]);
      promises.forEach((prom, i) => {
        if (!prom.ok) {
          throw new Error(
            `Organizations.user(${id}): Impossible to complete request #${i} - ${JSON.stringify(prom.result)}`
          );
        }
      });
      const [user, colleagues, teams] = promises.map((x) => x.result);
      return {
        user,
        colleagues,
        teams
      };
    });
  }
  userColleagues(id) {
    return this.requestWithStatus(
      "GET",
      `/users/${encodeURIComponent(id)}/colleagues`
    );
  }
  userUpdate(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/users/${encodeURIComponent(id)}`,
        body
      );
    });
  }
  userDelete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/users/${encodeURIComponent(id)}`
      );
    });
  }
  /**
   * Gets all of an organizations offices
   */
  offices() {
    return __async(this, null, function* () {
      const noAdminEndpoint = "/v1/offices";
      const adminEndpoint = "/integrations/offices";
      const response = yield this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? adminEndpoint : noAdminEndpoint}?limit=` + BaseOrganizationEndpoints.MAXIMUM_LIMIT
      );
      if (!response.ok) {
        return response;
      }
      return __spreadProps(__spreadValues({}, response), {
        result: response && response.result && response.result.elements && response.result.elements.length > 0 ? yield this.formatOffices(response.result) : null
      });
    });
  }
  /**
   * Returns the details of a single office
   */
  office(id) {
    return __async(this, null, function* () {
      const office = yield this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/offices/${encodeURIComponent(id)}`
      );
      return office;
    });
  }
  officeAdd(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/offices", body);
    });
  }
  officeUpdate(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/offices/${encodeURIComponent(id)}`,
        body
      );
    });
  }
  officeDelete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/offices/${encodeURIComponent(id)}`
      );
    });
  }
  updateOfficeReservationSettings(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/offices/${encodeURIComponent(id)}/reservation/settings`,
        body
      );
    });
  }
  /**
   * @deprecated use teams.all()
   */
  teams(showHidden = false) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/teams${showHidden ? "?hidden" : ""}`
      );
    });
  }
  /**
   * @deprecated use teams.all()
   */
  teamsWithOptions(showHidden = false) {
    return __async(this, null, function* () {
      const res = yield this.teams(showHidden);
      if (res.ok && res.result) {
        return __spreadProps(__spreadValues({}, res), {
          result: formatOptions(res.result)
        });
      }
      return res;
    });
  }
  /*
   * Returns all users asigned to a specific team
   *
   * @param id The id of the team
   * @param query text search on ????? TODO: Figure out what TEXT_SEARCH_CONFIGURATION applies
   * @returns
   *
   * @deprecated
   */
  teamUsers(id, query = null) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/teams/${encodeURIComponent(id)}/users${query ? `?query=${encodeURIComponent(query)}` : ""}`
      );
    });
  }
  /**
   * @deprecated use teams.add()
   */
  teamAdd(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/teams", body);
    });
  }
  /**
   * @deprecated use teams.update()
   */
  teamUpdate(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/teams/${encodeURIComponent(id)}`,
        body
      );
    });
  }
  /**
   * @deprecated use teams.delete()
   */
  teamDelete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/teams/${encodeURIComponent(id)}`
      );
    });
  }
  /**
   * @deprecated use teams.addMember()
   */
  teamAddUser(teamId, userId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        `/teams/${encodeURIComponent(teamId)}/users/${userId}`
      );
    });
  }
  /**
   * @deprecated use teams.removeMember()
   */
  teamDeleteUser(teamId, userId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/teams/${encodeURIComponent(teamId)}/users/${userId}`
      );
    });
  }
  resources(officeId) {
    return __async(this, null, function* () {
      const resources = yield this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/resources?limit=${BaseOrganizationEndpoints.MAXIMUM_LIMIT}`
      );
      if (!resources.ok || !resources.result) {
        return resources;
      }
      const result = this.resourceList(resources.result);
      return __spreadProps(__spreadValues({}, resources), { result });
    });
  }
  getSchedulableResources(filters) {
    return __async(this, null, function* () {
      const params = this.getGetResourcesFilterParams(filters);
      const resources = yield this.requestWithStatus(
        "GET",
        `/v1/resources/schedulable?${params.toString()}`
      );
      if (!resources.ok || !resources.result) {
        return resources;
      }
      return __spreadProps(__spreadValues({}, resources), { result: this.resourceList(resources.result) });
    });
  }
  schedulable(_0, _1) {
    return __async(this, arguments, function* (officeId, types, parentId = null, date = null, duration = null, query = null, limit = BaseOrganizationEndpoints.MAXIMUM_LIMIT, hierarchy = false, manage = false, organizer = null) {
      const resources = yield this.resourcesAll(
        officeId,
        types,
        parentId,
        "schedulable",
        false,
        date,
        query,
        duration,
        limit,
        hierarchy,
        manage,
        organizer
      );
      if (!resources.ok || !resources.result) {
        return resources;
      }
      return __spreadProps(__spreadValues({}, resources), { result: this.resourceList(resources.result) });
    });
  }
  getGetResourcesFilterParams(filters) {
    const params = new URLSearchParams();
    if (filters.hierarchy) {
      params.append("hierarchy", "1");
    }
    if (filters.manage) {
      params.append("manage", "1");
    }
    if (filters.organizerId) {
      params.append("organizer", filters.organizerId);
    }
    for (const type of filters.types) {
      params.append("type", type);
    }
    if (Array.isArray(filters.tags) && filters.tags.length) {
      for (const tag of filters.tags) {
        params.append("tags", tag);
      }
    }
    if (filters.tags_operator) {
      params.append("tags_operator", filters.tags_operator);
    }
    if (filters.parentId) {
      params.append("parent", filters.parentId);
    }
    if (filters.officeId) {
      params.append("office_id", filters.officeId);
    }
    if (filters.startDate && filters.endDate) {
      params.append("start_time", filters.startDate);
      params.append("end_time", filters.endDate);
    }
    const dates = typeof filters.date === "string" ? [filters.date] : filters.date;
    if (dates) {
      dates.forEach((x) => {
        params.append("date", x);
        if (filters.duration) {
          params.append("duration", filters.duration.toString());
        }
      });
    }
    if (filters.query) {
      params.append("query", filters.query);
    }
    if (filters.limit) params.set("limit", filters.limit.toString());
    return params;
  }
  getAllResources(filters) {
    return __async(this, null, function* () {
      var _a;
      const {
        officeId,
        types,
        parentId = null,
        filter = null,
        extended = true,
        date = null,
        query = null,
        duration = null,
        limit = BaseOrganizationEndpoints.MAXIMUM_LIMIT,
        hierarchy = false,
        manage = false,
        organizerId = null
      } = filters;
      if (types.length === 0) {
        throw new Error("At least one type is required");
      }
      const params = this.getGetResourcesFilterParams({
        officeId,
        types,
        parentId,
        date,
        query,
        duration,
        limit,
        hierarchy,
        manage,
        organizerId
      });
      const resources = yield this.requestWithStatus(
        "GET",
        `/v1/resources${filter ? `/${encodeURIComponent(filter)}` : ""}?${params.toString()}`
      );
      if (!extended) {
        return resources;
      }
      if (!resources.ok || !resources.result) {
        return resources;
      }
      const byId = {};
      const options = [];
      for (const element of ((_a = resources.result) == null ? void 0 : _a.elements) || []) {
        byId[element.id] = element;
        options.push({ value: element.id, label: element.name });
      }
      const result = __spreadProps(__spreadValues({}, resources.result), {
        byId,
        options
      });
      return __spreadProps(__spreadValues({}, resources), { result });
    });
  }
  resourcesAll(_0, _1) {
    return __async(this, arguments, function* (officeId, types, parentId = null, filter = null, extended = true, date = null, query = null, duration = null, limit = BaseOrganizationEndpoints.MAXIMUM_LIMIT, hierarchy = false, manage = false, organizerId = null) {
      var _a;
      if (types.length === 0) {
        throw new Error("At least one type is required");
      }
      const params = this.getGetResourcesFilterParams({
        officeId,
        types,
        parentId,
        date,
        query,
        duration,
        limit,
        hierarchy,
        manage,
        organizerId
      });
      const resources = yield this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/offices/${encodeURIComponent(officeId)}/resources${filter ? `/${encodeURIComponent(filter)}` : ""}?${params.toString()}`
      );
      if (!extended) {
        return resources;
      }
      if (!resources.ok || !resources.result) {
        return resources;
      }
      const byId = {};
      const options = [];
      for (const element of ((_a = resources.result) == null ? void 0 : _a.elements) || []) {
        byId[element.id] = element;
        options.push({ value: element.id, label: element.name });
      }
      const result = __spreadProps(__spreadValues({}, resources.result), {
        byId,
        options
      });
      return __spreadProps(__spreadValues({}, resources), { result });
    });
  }
  resourceGet(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/v1/resources/${encodeURIComponent(id)}`
      );
    });
  }
  /**
   * @deprecated Makes not sense to use a body of type string use `resourcePost`
   */
  resourceAdd(officeId, type, body) {
    return __async(this, null, function* () {
      const request = this.getResourceEntity(type, body);
      return yield this.requestWithStatus(
        "POST",
        `/offices/${encodeURIComponent(officeId)}/resources`,
        JSON.stringify(request)
      );
    });
  }
  /**
   * @deprecated Makes not sense to use a body of type string use `resourcePut`
   */
  resourceUpdate(id, body) {
    return __async(this, null, function* () {
      const request = this.getResourceEntity(null, body);
      return yield this.requestWithStatus(
        "PUT",
        `/resources/${encodeURIComponent(id)}`,
        JSON.stringify(request)
      );
    });
  }
  resourcePut(id, request) {
    return __async(this, null, function* () {
      const body = this.prepareRequest(request);
      return this.requestWithStatus(
        "PUT",
        `/resources/${encodeURIComponent(id)}`,
        body
      );
    });
  }
  resourcePost(officeId, request) {
    return __async(this, null, function* () {
      const body = this.prepareRequest(request);
      return this.requestWithStatus(
        "POST",
        `/offices/${encodeURIComponent(officeId)}/resources`,
        body
      );
    });
  }
  batchResourcePost(resources) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", "/v1/resources/batch", {
        resources: resources.map((resource) => {
          const data = this.prepareRequest(resource);
          data.office_id = resource.office_id || "";
          return data;
        })
      });
    });
  }
  batchResourcePut(resources) {
    return __async(this, null, function* () {
      return this.requestWithStatus("PUT", "/v1/resources/batch", {
        resources: resources.map((resource) => {
          return __spreadProps(__spreadValues({}, resource), { office_id: resource.office_id });
        })
      });
    });
  }
  batchResourceDelete(ids) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        "/v1/resources/batch",
        {
          resource_ids: ids.map((id) => {
            return id;
          })
        }
      );
    });
  }
  integrationsResourcePost(admin, officeId, request) {
    return __async(this, null, function* () {
      const body = this.prepareRequest(request);
      const response = yield this.requestWithStatus(
        "POST",
        `/integrations/offices/${encodeURIComponent(officeId)}/resources`,
        body
      );
      if (!response.ok) {
        return response;
      }
      return response;
    });
  }
  resourceMediaDelete(resourceId, mediaId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/resources/${encodeURIComponent(resourceId)}/media/${mediaId}`
      );
    });
  }
  resourceMedia(resourceId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/resources/${encodeURIComponent(resourceId)}/media`
      );
    });
  }
  resourceMediaUpload(resourceId, file, replaceAll = false, onProgress) {
    return __async(this, null, function* () {
      var _a, _b;
      const uploadUri = yield this.resourceCreateMediaUri(resourceId);
      if (!uploadUri.ok || !uploadUri.result) {
        throw new Error("Could not get upload uri");
      }
      const upload = yield this.resourceMediaUploadToProvider(
        uploadUri.result,
        file,
        onProgress
      );
      if (!upload.success) {
        throw new Error("Could not upload file");
      }
      const uri = yield this.resourceMediaUri(resourceId, uploadUri.result.id);
      return this.resourceMediaAttachToResource(
        resourceId,
        (_b = (_a = uri.result) == null ? void 0 : _a.uri) != null ? _b : "",
        uploadUri.result.id,
        replaceAll
      );
    });
  }
  resourceMediaAttachToResource(resourceId, uri, uploadId, replaceAll = false) {
    return __async(this, null, function* () {
      if (replaceAll) {
        const resource = yield this.resourceGet(resourceId);
        if (!resource.ok || !resource.result) {
          throw new Error("Could not get resource");
        }
        return this.requestWithStatus(
          "PUT",
          `/resources/${encodeURIComponent(resourceId)}`,
          __spreadProps(__spreadValues({}, resource.result.resource), {
            medias_patch: false,
            medias: [
              {
                upload_id: uploadId,
                type: "image",
                uri
              }
            ]
          })
        );
      }
      return this.requestWithStatus(
        "POST",
        `/resources/${encodeURIComponent(resourceId)}/media`,
        {
          type: "image",
          uri,
          upload_id: uploadId
        }
      );
    });
  }
  resourceCreateMediaUri(resourceId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/resources/${encodeURIComponent(resourceId)}/media/upload/image`
      );
    });
  }
  resourceMediaUri(resourceId, uploadId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/resources/${encodeURIComponent(resourceId)}/media/upload/image/${encodeURIComponent(uploadId)}`
      );
    });
  }
  resourceMediaUploadToProvider(url, file, onProgress) {
    return __async(this, null, function* () {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const formData = new FormData();
        formData.append("file", file);
        xhr.open("POST", url.uri, true);
        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable && onProgress) {
            onProgress(event.loaded / event.total * 100);
          }
        };
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              const json = JSON.parse(xhr.responseText);
              resolve(json);
            } catch (err) {
              reject(new Error("Invalid JSON response"));
            }
          } else {
            reject(
              new Error(
                `Upload failed with status ${xhr.status}: ${xhr.responseText}`
              )
            );
          }
        };
        xhr.onerror = () => {
          reject(new Error("Network error during upload"));
        };
        xhr.send(formData);
      });
    });
  }
  prepareRequest(request) {
    var _a, _b, _c;
    const type = request.type;
    if (!type) {
      throw new Error("No resource type");
    }
    const isArea = type == "area";
    const isOpen = typeof request.is_open !== "undefined" && request.is_open;
    const totalSlots = (_a = request.total_slots) != null ? _a : 1;
    const maximumSlotsPerUser = (_b = request.maximum_slots_per_user) != null ? _b : 1;
    const medias = (_c = request.medias) != null ? _c : [];
    return {
      type,
      name: request.name,
      description: request.description,
      map_url: request.map_url,
      label: request.label,
      parent_id: request.parent_id,
      total_slots: !isArea ? totalSlots : 0,
      maximum_slots_per_user: !isArea ? maximumSlotsPerUser : 0,
      is_available: request.is_available,
      is_open: isOpen,
      is_approvable: request.is_approvable,
      weight: request.weight,
      medias,
      // This prevents API to reset the medias when updating a resource
      medias_patch: true,
      map_data: request.map_data
    };
  }
  resourceManagerPermissionsAll(userId, filter) {
    return __async(this, null, function* () {
      const params = new URLSearchParams();
      params.append("type", "area");
      params.append("type", "desk");
      params.append("type", "workspace");
      params.append("type", "meeting_room");
      return this.requestWithStatus(
        "GET",
        `/users/${userId}/resources/managed?${params.toString()}`
      );
    });
  }
  resourceManagerPermissionsAdd(request) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", `/resources/managers`, request);
    });
  }
  resourceManagerPermissionsDelete(res, userId) {
    return __async(this, null, function* () {
      if (!res.manage) {
        throw new Error(`Delete can't be called without manage.`);
      }
      return yield this.requestWithStatus(
        "DELETE",
        `/resources/${encodeURIComponent(res.id)}/managers/${encodeURIComponent(res.manage.permission_id)}/user/${userId}`
      );
    });
  }
  resourceDelete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/v1/resources/${encodeURIComponent(id)}`
      );
    });
  }
  resourceScheduledPermissions(id, filter) {
    return __async(this, null, function* () {
      return this.resourceScheduledPermissionsAll([id], filter);
    });
  }
  resourceScheduledPermissionsAll(ids, filter) {
    return __async(this, null, function* () {
      const params = new URLSearchParams();
      ids.forEach((id) => params.append("resource", id));
      if (filter && filter.hierarchy) {
        params.append("hierarchy", "true");
      }
      if (filter && filter.includePast) {
        params.append("includePast", "true");
      }
      return this.requestWithStatus(
        "GET",
        `/resources/permissions?${params.toString()}`
      );
    });
  }
  resourceScheduledPermissionsAdd(request) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        `/resources/permissions`,
        request
      );
    });
  }
  getResourceAdditionalAccess(resourceId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/v1/resources_additional_access?resource_id=${resourceId}`
      );
    });
  }
  setResourceAdditionalAccessOptions(resourceId, options) {
    return __async(this, null, function* () {
      const existingOptions = yield this.getResourceAdditionalAccess(resourceId);
      const existingOption = (existingOptions.result || []).find(
        (option) => option.resource_id === resourceId
      );
      const additionalAccessData = __spreadProps(__spreadValues({}, options), {
        resource_id: resourceId
      });
      return this.requestWithStatus(
        existingOption ? "PUT" : "POST",
        `/v1/resources_additional_access${existingOption ? `/${existingOption.id}` : ""}`,
        additionalAccessData
      );
    });
  }
  resourceScheduledPermissionsUpdate(request, resourceId, permissionId, teamId, userId) {
    return __async(this, null, function* () {
      const permissionType = teamId ? `team/${teamId}` : `user/${userId}`;
      return yield this.requestWithStatus(
        "PUT",
        `/resources/${encodeURIComponent(resourceId)}/permissions/${encodeURIComponent(permissionId)}/${permissionType}`,
        request
      );
    });
  }
  resourceScheduledPermissionsDelete(permission) {
    return __async(this, null, function* () {
      let permissionType = "";
      if (permission.team) {
        permissionType = `team/${permission.team.id}`;
      } else if (permission.user) {
        permissionType = `user/${permission.user.id}`;
      }
      return yield this.requestWithStatus(
        "DELETE",
        `/resources/${encodeURIComponent(permission.resource_id)}/permissions/${encodeURIComponent(
          permission.id
        )}/${permissionType}`
      );
    });
  }
  newsAdd(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/news", body);
    });
  }
  news(office_id = null) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        (office_id !== null ? `/offices/${encodeURIComponent(office_id)}/news` : "/news") + "?limit=" + BaseOrganizationEndpoints.MAXIMUM_LIMIT
      );
    });
  }
  getNews(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        "/news/" + encodeURIComponent(id)
      );
    });
  }
  newsUpdate(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/news/${encodeURIComponent(id)}`,
        body
      );
    });
  }
  newsDelete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/news/${encodeURIComponent(id)}`
      );
    });
  }
  questionAdd(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/questions", body);
    });
  }
  questions() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        "/questions?limit=" + BaseOrganizationEndpoints.MAXIMUM_LIMIT
      );
    });
  }
  question(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/questions/${encodeURIComponent(id)}`
      );
    });
  }
  questionUpdate(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/questions/${encodeURIComponent(id)}`,
        body
      );
    });
  }
  questionDelete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/questions/${encodeURIComponent(id)}`
      );
    });
  }
  /**
   * Returns health questionnaire questions for the specified office.
   *
   * @param officeId The office id to get the health questionnaire for
   * @param questionnaireId Optional parameter get details about a specific questionnaire
   */
  questionnaire(officeId, questionnaireId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        questionnaireId ? `/questionnaires/${encodeURIComponent(questionnaireId)}` : `/offices/${encodeURIComponent(officeId)}/questionnaire`
      );
    });
  }
  /**
   * Responds to a health questionnaires questions, triggered by a reservation in an office that requires one.
   *
   * @param officeId The office ID to which the reservation belongs
   * @param body The full body of the request
   */
  questionnaireRespond(officeId, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/offices/${encodeURIComponent(officeId)}/questionnaire`,
        body
      );
    });
  }
  /**
   * @deprecated use schedules.checkin(res, schedule, slot)
   * @param id
   */
  checkin(id) {
    return __async(this, null, function* () {
      console.log("warn: [checkin] function is deprecated");
      return yield this.requestWithStatus(
        "POST",
        `/resources/${encodeURIComponent(id)}/presence`
      );
    });
  }
  assignTag(tagId, resourceId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/tags/${encodeURIComponent(tagId)}/assign/${encodeURIComponent(resourceId)}`
      );
    });
  }
  getAssignedResource(tagId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/tags/${encodeURIComponent(tagId)}`
      );
    });
  }
  generateOtp() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        "/codes"
      );
    });
  }
  uploadSignature(formId, signature) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/forms/${formId}/sign`,
        signature
      );
    });
  }
  notificationListen(listener) {
    return __async(this, null, function* () {
      const accessToken = this.getAccessToken();
      const slug = this.getSlug();
      if (accessToken === null || slug === null) {
        throw new Error("Missing access token or slug");
      }
      const url = this.getBaseUrl();
      const connection = new signalR.HubConnectionBuilder().withUrl(`${url}/hub/notifications`, {
        accessTokenFactory: () => accessToken,
        headers: {
          "X-Tactic-Orgz": slug
        }
      }).build();
      connection.on("added", (type, json) => {
        const data = json !== null ? JSON.parse(json) : null;
        listener(type, data);
      });
      return connection;
    });
  }
  formatOffices(offices, user) {
    const defaultOfficeNotDeleted = user ? offices.elements.some(
      (office2) => office2.id === user.organization_user.default_office_id
    ) : false;
    const officeId = user && defaultOfficeNotDeleted ? user.organization_user.default_office_id : offices.elements[0].id;
    let office = null, byId = {};
    for (const currentOffice of offices.elements) {
      byId[currentOffice.id] = currentOffice;
      if (office == null && currentOffice.id == officeId) {
        office = currentOffice;
      }
    }
    const result = {
      officeId,
      office,
      offices: offices.elements,
      byId
    };
    return result;
  }
  normalizeEntityCollection(collection) {
    return Array.isArray(collection) ? collection : Object.keys(collection).map((value) => ({ value }));
  }
  getResourceEntity(type, body) {
    const posted = JSON.parse(body);
    type = type !== null && type.indexOf(",") < 0 ? type : posted.type || null;
    if (!type) {
      throw new Error("No resource type");
    }
    const isArea = type == "area";
    const isApprovable = typeof posted.is_approvable !== "undefined" && posted.is_approvable == true;
    const isOpen = typeof posted.is_open !== "undefined" && posted.is_open;
    const teams = posted.teams ? this.normalizeEntityCollection(posted.teams) : [];
    const users = posted.users ? this.normalizeEntityCollection(posted.users) : [];
    const usersSettings = {};
    const teamsSettings = {};
    for (const option of users) {
      usersSettings[option.value] = isApprovable;
    }
    for (const option of teams) {
      teamsSettings[option.value] = isApprovable;
    }
    const totalSlots = posted.total_slots && Number.parseInt(posted.total_slots, 10) > 0 ? Number.parseInt(posted.total_slots, 10) : 1;
    const maximumSlotsPerUser = posted.maximum_slots_per_user && Number.parseInt(posted.maximum_slots_per_user, 10) > 0 ? Number.parseInt(posted.maximum_slots_per_user, 10) : 1;
    return {
      type,
      name: posted.name,
      map_url: posted.map_url,
      parent_id: posted.parent_id,
      total_slots: !isArea ? totalSlots : 0,
      maximum_slots_per_user: !isArea ? maximumSlotsPerUser : 0,
      is_available: posted.is_available,
      is_open: isOpen,
      is_approvable: isApprovable,
      teams: teamsSettings,
      users: usersSettings,
      weight: posted.weight
    };
  }
  resourceList(resources) {
    return resources !== null && resources.tree !== void 0 && resources.tree !== null ? this.formatTree(resources.tree, _Organizations.resourceFormatter) : [];
  }
  getJoinUrl(joinCode) {
    return this.getUrl(`signup?join=${encodeURIComponent(joinCode)}`);
  }
  getUploadUrl(options, file) {
    return __async(this, null, function* () {
      const queryParams = new URLSearchParams({
        type: options.type,
        format: options.format
      });
      return this.requestWithStatus(
        "POST",
        `/v1/uploads/images/url?${queryParams.toString()}`,
        file
      );
    });
  }
  getGanttOverviewEntities(officeId, filters) {
    return __async(this, null, function* () {
      var _a;
      return this.requestWithStatus(
        "GET",
        `/v1/dashboard/offices/${officeId}/gantt_overview${objectToQueryString({
          start: filters.start.toISOString(),
          end: filters.end.toISOString(),
          limit: (_a = filters.limit) == null ? void 0 : _a.toString(),
          cursor: filters.cursor,
          floor_id: filters.floorId,
          resource_type: filters.resourceType
        })}`
      );
    });
  }
};

// src/utils/objectToFiltersQuery.ts
function objectToFiltersQuery(obj) {
  if (!obj) return "";
  const params = new URLSearchParams();
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (value === void 0 || value === null || value === "" || Array.isArray(value) && value.length === 0) {
      return;
    }
    if (Array.isArray(value)) {
      params.append(key, value.join(","));
    } else {
      params.append(key, String(value));
    }
  });
  const queryString = params.toString();
  return queryString ? `?${queryString}` : "";
}

// src/endpoints/pages.ts
var Pages = class extends BaseOrganizationEndpoints {
  getSections() {
    return __async(this, null, function* () {
      return this.requestWithStatus("GET", "/v1/sections");
    });
  }
  updateSection(id, section) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/v1/sections/${id}`,
        __spreadProps(__spreadValues({}, section), { id })
      );
    });
  }
  deleteSection(idSection) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/v1/sections/${idSection}`
      );
    });
  }
  deletePage(idPage) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/v1/pages/${idPage}`
      );
    });
  }
  createSection(section) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", "/v1/sections", section);
    });
  }
  getPages(filters) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        "/v1/pages" + objectToFiltersQuery(filters)
      );
    });
  }
  getPage(pageFilters) {
    return __async(this, null, function* () {
      if (!pageFilters.id) throw new Error("Page ID is required");
      return yield this.requestWithStatus(
        "GET",
        `/v1/pages/${pageFilters.id}`
      );
    });
  }
  createPage(post) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", "/v1/pages", post);
    });
  }
  updatePage(idPost, post) {
    return __async(this, null, function* () {
      return this.requestWithStatus("PUT", `/v1/pages/${idPost}`, post);
    });
  }
};

// src/endpoints/reports.ts
import { format as format4 } from "date-fns";
var _Reports = class _Reports extends BaseOrganizationEndpoints {
  usage(filter) {
    return __async(this, null, function* () {
      const requestUrl = _Reports.url("usage", filter);
      const result = yield this.requestWithStatus(
        "GET",
        requestUrl
      );
      return result;
    });
  }
  resources(filter, cursor = null) {
    return __async(this, null, function* () {
      const requestUrl = _Reports.url("resources", filter, cursor);
      const result = yield this.requestWithStatus(
        "GET",
        requestUrl
      );
      return result;
    });
  }
  reservations(filter, cursor = null) {
    return __async(this, null, function* () {
      const requestUrl = _Reports.url("reservations", filter, cursor);
      const result = yield this.requestWithStatus(
        "GET",
        requestUrl
      );
      return result;
    });
  }
  static url(report, filter, cursor = null) {
    var _a;
    const limit = (_a = filter.limit) != null ? _a : _Reports.DEFAULT_LIMIT;
    let url = `/reports/${report}?start=${encodeURIComponent(format4(filter.start, "yyyy-MM-dd"))}&end=${encodeURIComponent(format4(filter.end, "yyyy-MM-dd"))}`;
    if (filter.search !== null) {
      url += `&search=${encodeURIComponent(filter.search)}`;
    }
    for (const id of filter.officeIds) {
      url += `&office=${encodeURIComponent(id)}`;
    }
    for (const type of filter.resourceTypes) {
      url += `&type=${encodeURIComponent(type)}`;
    }
    if (cursor !== null) {
      url += `&cursor=${encodeURIComponent(cursor)}`;
    }
    if (limit && _Reports.REPORTS_WITH_LIMIT.includes(report)) {
      url += `&limit=${encodeURIComponent(limit)}`;
    }
    return url;
  }
};
_Reports.DEFAULT_LIMIT = 20;
_Reports.REPORTS_WITH_LIMIT = ["reservations", "resources"];
var Reports = _Reports;

// src/entities/hours.ts
var ALL_WEEK_DAYS = Object.freeze([
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
]);

// src/entities/presence.ts
var PRESENCE_STATUS_ACCEPTED = "accepted";
var PRESENCE_STATUS_PENDING = "pending";
var PRESENCE_STATUS_REJECTED = "rejected";
var PRESENCE_TYPE_IN_PERSON = "in_person";
var PRESENCE_TYPE_REMOTE = "remote";
var PRESENCE_TYPE_OOO = "out_of_office";

// src/endpoints/schedules.ts
var _Schedules = class _Schedules extends BaseOrganizationEndpoints {
  formatScheduleParams(params = {}) {
    const urlParams = this.formatGenericParams(params);
    if (!urlParams.has("weeks")) {
      urlParams.set("weeks", _Schedules.DEFAULT_NUMBER_OF_WEEKS.toString());
    }
    urlParams.set("fetchSimple", "1");
    return urlParams;
  }
  processFilter(requestUrl, filter) {
    if (filter.schedule_statuses) {
      for (const status of filter.schedule_statuses) {
        requestUrl += `&status=${encodeURIComponent(status)}`;
      }
    }
    if (filter.schedule_types) {
      for (const schedule_type of filter.schedule_types) {
        requestUrl += `&schedule_type=${encodeURIComponent(schedule_type)}`;
      }
    }
    if (filter.slot_types) {
      for (const slot_type of filter.slot_types) {
        if (slot_type)
          requestUrl += `&slot_type=${encodeURIComponent(slot_type)}`;
      }
    }
    if (filter.type) {
      for (const type of filter.type) {
        requestUrl += `&type=${encodeURIComponent(type)}`;
      }
    }
    if (filter.is_for_others) {
      requestUrl += "&isForOthers=true";
    }
    if (filter.tz) {
      requestUrl += `&tz=${encodeURIComponent(filter.tz)}`;
    }
    return requestUrl;
  }
  /** @deprecated use `all(...)` */
  schedules(_0, _1, _2) {
    return __async(this, arguments, function* (office_id, start, end, user_id = null, status_filter = ["accepted", "pending"]) {
      let requestUrl = `/offices/${encodeURIComponent(office_id)}/schedules?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`;
      for (const filter of status_filter) {
        requestUrl += `&presence=${encodeURIComponent(filter)}`;
      }
      for (const filter of status_filter) {
        requestUrl += `&status=${encodeURIComponent(filter)}`;
      }
      if (user_id !== null) {
        requestUrl += `&user=${encodeURIComponent(user_id)}`;
      }
      const result = yield this.requestWithStatus(
        "GET",
        requestUrl
      );
      return result;
    });
  }
  // Duplicate of organizations.questionnaire
  questionnaire(office_id) {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(office_id)}/questionnaire`
      );
      return result;
    });
  }
  news(office_id) {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(office_id)}/news`
      );
      return result;
    });
  }
  /** @deprecated Use `all(...)` instead */
  me(_0) {
    return __async(this, arguments, function* (office_id, time_zone = null, date = null, params = {}) {
      var _a, _b;
      const urlParams = new URLSearchParams();
      if (date) {
        urlParams.set("date", date);
      }
      urlParams.set(
        "weeks",
        ((_a = params.weeks) != null ? _a : _Schedules.DEFAULT_NUMBER_OF_WEEKS).toString()
      );
      if (params.limit) {
        urlParams.set("limit", params.limit.toString());
      }
      if (params.type !== null && params.type !== void 0) {
        for (let i = 0; i < ((_b = params.type) == null ? void 0 : _b.length); i++) {
          urlParams.append("type", params.type[i]);
        }
      }
      const result = yield this.requestWithStatus(
        "GET",
        `/offices/${office_id}/schedules/me?${urlParams.toString()}`
      );
      return result;
    });
  }
  all(filter, params, useCore = false) {
    return __async(this, null, function* () {
      const urlParams = this.formatScheduleParams(params);
      let url = `${this.settings.adminAuth ? "/integrations" : ""}/schedules/${filter}?${urlParams.toString()}`;
      if (filter === "occupied" && useCore) {
        url = `/v1/schedules/occupied?${urlParams.toString()}`;
      } else if (filter === "managed") {
        url = `/v1/schedules/managed?${urlParams.toString()}`;
      } else if (filter === "pending") {
        urlParams.set("only_pending", "");
        url = `/v1/schedules/managed?${urlParams.toString()}`;
      }
      return this.requestWithStatus("GET", url);
    });
  }
  allIndexed(filter, params, useCore = false) {
    return __async(this, null, function* () {
      var _a;
      const ret = yield this.all(filter, params, useCore);
      const uniqueUsers = {};
      const scheduleByUserByDay = {};
      const schedulesByDay = {};
      const result = ret.result;
      ((_a = result.elements) != null ? _a : []).forEach((x) => {
        const days = getDaysWithinTimespan(x.start, x.end, x.time_zone);
        days.forEach((day) => {
          var _a2, _b, _c;
          const user = x.user || x.organizer;
          uniqueUsers[user.id] = user;
          schedulesByDay[day] = (_a2 = schedulesByDay[day]) != null ? _a2 : [];
          schedulesByDay[day].push(x);
          scheduleByUserByDay[user.id] = (_b = scheduleByUserByDay[user.id]) != null ? _b : {};
          scheduleByUserByDay[user.id][day] = (_c = scheduleByUserByDay[user.id][day]) != null ? _c : [];
          scheduleByUserByDay[user.id][day].push(x);
        });
      });
      return __spreadProps(__spreadValues({}, ret), {
        result: __spreadProps(__spreadValues({}, result), {
          dates: schedulesByDay,
          dates_user: scheduleByUserByDay,
          users: uniqueUsers
        })
      });
    });
  }
  allUsage(filter, params) {
    return __async(this, null, function* () {
      const urlParams = this.formatScheduleParams(params);
      return this.requestWithStatus(
        "GET",
        `/schedules/${filter}/usage?${urlParams.toString()}`
      );
    });
  }
  workingLocations() {
    return __async(this, arguments, function* (params = {}) {
      const urlParams = this.formatScheduleParams(params);
      return this.requestWithStatus(
        "GET",
        `/working_locations?${urlParams.toString()}`
      );
    });
  }
  workingLocationsDefaults(userId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/working_locations/${userId}`
      );
    });
  }
  updateWorkingLocationDefaults(locations) {
    return __async(this, null, function* () {
      const body = {
        locations
      };
      return this.requestWithStatus("POST", "/working_locations", body);
    });
  }
  updateWorkingLocationDay(location, day, date) {
    return __async(this, null, function* () {
      const dayIdx = ALL_WEEK_DAYS[day];
      const body = {
        locations: {
          [dayIdx]: location
        },
        start: `${date}T00:00:00Z`,
        end: `${date}T23:59:59Z`
      };
      return this.requestWithStatus("POST", "/working_locations", body);
    });
  }
  schedulesById(schedule_ids, office_id = null, filter) {
    return __async(this, null, function* () {
      let requestUrl = `/offices/${office_id}/schedules`;
      if (office_id == null) {
        requestUrl = `/schedules`;
      }
      for (let i = 0; i < schedule_ids.length; i++) {
        if (i === 0) {
          requestUrl += `?schedule=${encodeURIComponent(schedule_ids[i])}`;
        } else {
          requestUrl += `&schedule=${encodeURIComponent(schedule_ids[i])}`;
        }
      }
      if (filter) {
        requestUrl = this.processFilter(requestUrl, filter);
        console.log("filter url", requestUrl);
      }
      return this.requestWithStatus("GET", requestUrl, null);
    });
  }
  /**
   * [DEPRECATED]
   *
   * Shows whether a user has permission for schedule:respond. This should now be called by looking at
   * authenticatedUser.user.permissions.includes('schedule:respond')
   *
   */
  canApprove() {
    return __async(this, null, function* () {
      const user = yield this.request("GET", "/user");
      const canApprove = user && user.organization_user !== void 0 && user.organization_user.permissions.includes("schedule:respond");
      return canApprove;
    });
  }
  /** @deprecated Use `all(...)` instead */
  pending(_0) {
    return __async(this, arguments, function* (office_id, time_zone = null, date = null, params = {}) {
      var _a;
      if (!this.canApprove()) {
        throw new Error("User can't call pending");
      }
      const urlParams = new URLSearchParams();
      if (date) {
        urlParams.set("date", date);
      }
      urlParams.set(
        "weeks",
        ((_a = params.weeks) != null ? _a : _Schedules.DEFAULT_NUMBER_OF_WEEKS).toString()
      );
      if (params.limit) {
        urlParams.set("limit", params.limit.toString());
      }
      return this.requestWithStatus(
        "GET",
        `/offices/${office_id}/schedules/pending?${urlParams.toString()}`
      );
    });
  }
  /** @deprecated Use `all(...)` instead */
  usage(office_id, time_zone = null, date = null) {
    return __async(this, null, function* () {
      const weekDate = date !== null ? encodeURIComponent(date) : null;
      const response = yield this.requestWithStatus(
        "GET",
        `/offices/${office_id}/schedules/occupied/usage?weeks=${_Schedules.DEFAULT_NUMBER_OF_WEEKS}${weekDate !== null ? "&date=" + weekDate : ""}`
      );
      if (!response.ok || !response.result) {
        return response;
      }
      return __spreadProps(__spreadValues({}, response), { result: this.formatUsages(response.result) });
    });
  }
  /** @deprecated Use `allUsage(...)` instead */
  usageFull(office_id, time_zone = null, date = null) {
    return __async(this, null, function* () {
      const response = yield this.requestWithStatus(
        "GET",
        `/offices/${office_id}/schedules/occupied/usage?weeks=${_Schedules.DEFAULT_NUMBER_OF_WEEKS}${date !== null ? "&date=" + encodeURIComponent(date) : ""}`
      );
      return response;
    });
  }
  /** @deprecated Use `all(...)` instead */
  occupied(_0) {
    return __async(this, arguments, function* (office_id, time_zone = null, date = null, teams = [], resourceIds = [], limit = 1e3, types = []) {
      const weekDate = date !== null ? encodeURIComponent(date) : null;
      let query = `weeks=${_Schedules.DEFAULT_NUMBER_OF_WEEKS}${weekDate !== null ? "&date=" + weekDate : ""}`;
      for (const teamId of teams) {
        query += `&team=${encodeURIComponent(teamId)}`;
      }
      for (const resourceId of resourceIds) {
        query += `&resource=${encodeURIComponent(resourceId)}`;
      }
      for (const type of types) {
        query += `&type=${encodeURIComponent(type)}`;
      }
      query += `&limit=${limit}`;
      return yield this.requestWithStatus(
        "GET",
        `/offices/${office_id}/schedules/occupied?${query}`
      );
    });
  }
  /** @deprecated Use `all(...)` instead */
  scheduler(_0) {
    return __async(this, arguments, function* (office_id, time_zone = null, date = null, teams = [], resourceIds = [], limit = 1e3) {
      const weekDate = date !== null ? encodeURIComponent(date) : null;
      let query = `weeks=${_Schedules.DEFAULT_NUMBER_OF_WEEKS}${weekDate !== null ? "&date=" + weekDate : ""}`;
      for (const teamId of teams) {
        query += `&team=${encodeURIComponent(teamId)}`;
      }
      for (const resourceId of resourceIds) {
        query += `&resource=${encodeURIComponent(resourceId)}`;
      }
      query += `&limit=${limit}`;
      return yield this.requestWithStatus(
        "GET",
        `/offices/${office_id}/schedules/scheduler?${query}`
      );
    });
  }
  day(resource_id, time_zone = null, date = null) {
    return __async(this, null, function* () {
      const weekDate = date !== null ? encodeURIComponent(date) : null;
      const query = `weeks=${_Schedules.DEFAULT_NUMBER_OF_WEEKS}${weekDate !== null ? "&date=" + weekDate : ""}`;
      return yield this.requestWithStatus(
        "GET",
        `/resources/${resource_id}/schedules/day?${query}`,
        null
      );
    });
  }
  formatUsages(usageResult) {
    const usages = [];
    for (const date of Object.keys(usageResult.dates_type)) {
      const usagesByType = usageResult.dates_type[date];
      const hasDesks = typeof usagesByType.desk !== "undefined";
      const hasWorkspace = typeof usagesByType.workspace !== "undefined";
      const acceptedDesks = (hasDesks ? usagesByType.desk.accepted : 0) + (hasWorkspace ? usagesByType.workspace.accepted : 0);
      const freeDesks = (hasDesks ? usagesByType.desk.free : 0) + (hasWorkspace ? usagesByType.workspace.free : 0);
      const totalDesks = (hasDesks ? usagesByType.desk.total : 0) + (hasWorkspace ? usagesByType.workspace.total : 0);
      usages.push({
        date,
        day: date.substring(date.lastIndexOf("-") + 1),
        accepted: acceptedDesks,
        free: freeDesks,
        total: totalDesks,
        occupancy: totalDesks > 0 ? (100 * acceptedDesks / totalDesks).toFixed(0) : 0
      });
    }
    return {
      month: usageResult.months.start,
      usages,
      days: usageResult.days,
      weekDate: usageResult.week_date,
      previousWeekDate: usageResult.previous_week_date,
      nextWeekDate: usageResult.next_week_date
    };
  }
  respond(scheduleId, slotId, status) {
    return __async(this, null, function* () {
      const endpoint = slotId !== null ? `${this.settings.adminAuth ? "/integrations" : ""}/schedules/${encodeURIComponent(scheduleId)}/slots/${encodeURIComponent(
        slotId
      )}/respond/${encodeURIComponent(status)}` : `${this.settings.adminAuth ? "/integrations" : ""}/schedules/${encodeURIComponent(scheduleId)}/respond/${encodeURIComponent(status)}`;
      const result = yield this.requestWithStatus("PUT", endpoint);
      return __spreadProps(__spreadValues({}, result), { result: { scheduleId, slotId, status } });
    });
  }
  checkin(resourceId, scheduleId, slotId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        `${this.settings.adminAuth ? "/integrations" : ""}/resources/${encodeURIComponent(resourceId)}/presence/${encodeURIComponent(scheduleId)}/${encodeURIComponent(
          slotId
        )}`
      );
    });
  }
  checkout(resourceId, scheduleId, slotId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/resources/${encodeURIComponent(resourceId)}/presence/${encodeURIComponent(scheduleId)}/${encodeURIComponent(
          slotId
        )}`
      );
    });
  }
  delete(_0) {
    return __async(this, arguments, function* ({
      schedule,
      slot,
      recurring = false,
      slug = "",
      resourceId = ""
      // ? on slug is to accommodate mobile types before the slug was added
    }) {
      const body = recurring ? { recurring } : {};
      const newBasePath = getUrl({
        slug,
        officeId: void 0,
        method: "DELETE",
        resourceId
      });
      const oldBasePath = `${this.settings.adminAuth ? "/integrations" : ""}/schedules/`;
      const basePath = newBasePath || oldBasePath;
      const deletePath = slot ? `${basePath}${encodeURIComponent(schedule)}/slots/${encodeURIComponent(slot)}` : `${basePath}${encodeURIComponent(schedule)}`;
      return this.requestWithStatus("DELETE", deletePath, body);
    });
  }
  presence(scheduleId, slotId, presenceStatus, presenceType, skipIntegrationEvents) {
    return __async(this, null, function* () {
      let url = `/schedules/${encodeURIComponent(scheduleId)}/slots/${encodeURIComponent(
        slotId
      )}/presence/${encodeURIComponent(presenceStatus)}`;
      const data = {};
      if (skipIntegrationEvents) {
        url += "?skip-integration-events=true";
      }
      if (presenceStatus === PRESENCE_STATUS_ACCEPTED && presenceType) {
        data.presence_type = presenceType;
      }
      const response = yield this.requestWithStatus("PUT", url, data);
      return __spreadProps(__spreadValues({}, response), {
        result: { scheduleId, slotId, presenceStatus, presenceType }
      });
    });
  }
  create(officeId, request, isFromCalendar = false, slug = "") {
    const resId = request.schedule_slots[0].resource_id;
    const newUrl = getUrl({
      slug,
      officeId,
      method: "POST",
      resourceId: resId
    });
    let url = newUrl != null ? newUrl : `/offices/${encodeURIComponent(officeId)}/schedules`;
    if (isFromCalendar) {
      url += "?is-from-calendar=true";
    }
    console.log("THIS IS THE URL", url);
    return this.requestWithStatus("POST", url, request);
  }
  patch(scheduleId, request, isFromCalendar = false, orgSlug = "") {
    var _a, _b, _c;
    const resId = (_c = (_b = (_a = request.schedule_slots) == null ? void 0 : _a[0]) == null ? void 0 : _b.resource_id) != null ? _c : "";
    const newUrl = getUrl({
      slug: orgSlug,
      method: "PATCH",
      officeId: void 0,
      scheduleId,
      resourceId: resId
    });
    let url = newUrl || `/schedules/${encodeURIComponent(scheduleId)}`;
    if (isFromCalendar) {
      url += "?is-from-calendar=true";
    }
    return this.requestWithStatus("PATCH", url, request);
  }
  put(scheduleId, request, isFromCalendar = false, orgSlug = "") {
    var _a, _b, _c;
    const resId = (_c = (_b = (_a = request.schedule_slots) == null ? void 0 : _a[0]) == null ? void 0 : _b.resource_id) != null ? _c : "";
    const newUrl = getUrl({
      slug: orgSlug,
      officeId: void 0,
      method: "PATCH",
      scheduleId,
      resourceId: resId
    });
    let url = newUrl || `/schedules/${encodeURIComponent(orgSlug)}`;
    if (isFromCalendar) {
      url += "?is-from-calendar=true";
    }
    return this.requestWithStatus("PUT", url, request);
  }
  addToSchedule(officeId, scheduleId, request) {
    return this.requestWithStatus(
      "PUT",
      `/offices/${encodeURIComponent(officeId)}/schedules/${encodeURIComponent(scheduleId)}`,
      request
    );
  }
  createFromIntegrations(resourceId, request, isFromCalendar) {
    let url = `/resources/${encodeURIComponent(resourceId)}/schedules`;
    if (isFromCalendar) {
      url += "?is-from-calendar=true";
    }
    return this.requestWithStatus("POST", url, request);
  }
  createOrUpdateFromIntegrations(authorization, resourceId, request, isFromCalendar, scheduleId) {
    if (scheduleId === void 0) {
      scheduleId = null;
    }
    let url = `/integrations/resources/${encodeURIComponent(resourceId)}/schedules`;
    if (scheduleId !== null) {
      url += `/${scheduleId}`;
    }
    if (isFromCalendar) {
      url += "?is-from-calendar=true";
    }
    return this.requestWithStatus(
      scheduleId !== null ? "PUT" : "POST",
      url,
      request,
      {
        authHeader: `Basic ${authorization}`
      }
    );
  }
  /**
   * @deprecated
   */
  add(request) {
    return __async(this, null, function* () {
      const period = this.createPeriod(
        request.start,
        request.duration,
        request.time_zone
      );
      const scheduleRequest = {
        schedule_slots: [],
        time_zone: period.time_zone
      };
      request.users.forEach((userId) => {
        scheduleRequest.schedule_slots.push({
          resource_id: request.resource_id,
          user_id: userId,
          team_id: null,
          slots: 1,
          start: period.start,
          end: period.end,
          time_zone: period.time_zone
        });
      });
      request.teams.forEach((teamId) => {
        scheduleRequest.schedule_slots.push({
          resource_id: request.resource_id,
          user_id: null,
          team_id: teamId,
          slots: 1,
          start: period.start,
          end: period.end,
          time_zone: period.time_zone
        });
      });
      const response = yield this.create(request.office_id, scheduleRequest);
      if (!response.ok || response.result === null) {
        throw response;
      }
      return response.result;
    });
  }
  existsById(authorization, organizationId, scheduleId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/organizations/${organizationId}/schedules/${scheduleId}/exists`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
};
_Schedules.DEFAULT_NUMBER_OF_WEEKS = 1;
var Schedules = _Schedules;
var getEndpointForMethod = {
  core: {
    POST: () => "/v1/schedules",
    PATCH: ({ scheduleId = "" }) => `/v1/schedules/${encodeURIComponent(scheduleId)}`,
    PUT: ({ scheduleId = "" }) => `/v1/schedules/${encodeURIComponent(scheduleId)}`,
    DELETE: ({ scheduleId = "" }) => `/v1/schedules/${encodeURIComponent(scheduleId)}`
  },
  api: {
    POST: ({ officeId = "" }) => `/offices/${encodeURIComponent(officeId)}/schedules`,
    PATCH: ({ scheduleId = "" }) => `/schedules/${encodeURIComponent(scheduleId)}`,
    PUT: ({ scheduleId = "" }) => `/schedules/${encodeURIComponent(scheduleId)}`,
    DELETE: ({ scheduleId = "" }) => `/schedules/${encodeURIComponent(scheduleId)}`
  }
};
var getUrl = ({
  slug,
  officeId,
  resourceId = "",
  method,
  scheduleId
}) => {
  return getEndpointForMethod.core[method]({
    officeId,
    scheduleId
  });
};

// src/endpoints/settings.ts
var SETTINGS_BASE_PATH = "/v1/settings";
var ORGANIZATION_SETTINGS_PATH = `${SETTINGS_BASE_PATH}/organizations`;
var OFFICE_SETTINGS_PATH = `${SETTINGS_BASE_PATH}/offices`;
var SettingsClient = class extends BaseSettingsEndpoints {
  getOrganizationSettings() {
    return __async(this, null, function* () {
      return this.get(`${ORGANIZATION_SETTINGS_PATH}`);
    });
  }
  getOfficeSettings(id) {
    return __async(this, null, function* () {
      return this.get(`${OFFICE_SETTINGS_PATH}/${id}`);
    });
  }
  updateOfficeSettings(id, settings) {
    return __async(this, null, function* () {
      return this.update(
        `${OFFICE_SETTINGS_PATH}/${id}`,
        settings
      );
    });
  }
  updateOrganizationSettings(settings) {
    return __async(this, null, function* () {
      return this.update(
        `${ORGANIZATION_SETTINGS_PATH}`,
        settings
      );
    });
  }
  updateOfficeDefaultReservationTime(id, settings) {
    return __async(this, null, function* () {
      return this.updateOfficeSettings(id, {
        reservation_default_time: settings
      });
    });
  }
  updateOrganizationDefaultReservationTime(settings) {
    return __async(this, null, function* () {
      return this.updateOrganizationSettings({
        reservation_default_time: settings
      });
    });
  }
  cancelCustomOfficeHours(id) {
    return __async(this, null, function* () {
      return this.delete(`${OFFICE_SETTINGS_PATH}/${id}`);
    });
  }
  cancelCustomOrganizationHours() {
    return __async(this, null, function* () {
      return this.delete(`${ORGANIZATION_SETTINGS_PATH}`);
    });
  }
};

// src/endpoints/signatures.ts
var Signatures = class extends BaseOrganizationEndpoints {
  signatures(filter) {
    return __async(this, null, function* () {
      let query = "";
      if (filter.signature_id) {
        query += `?signature=${encodeURIComponent(filter.signature_id)}`;
      } else if (filter.user_id) {
        query += `?user=${encodeURIComponent(filter.user_id)}`;
      } else if (filter.visit_id) {
        query += `?visit=${encodeURIComponent(filter.visit_id)}`;
      }
      return this.requestWithStatus(
        "GET",
        `/signatures${query}`
      );
    });
  }
};

// src/endpoints/signups.ts
var Signups = class extends BasePublicEndpoints {
  add(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/users", body);
    });
  }
  getPendingByCode(code) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/invitation/${encodeURIComponent(code)}`
      );
    });
  }
};

// src/endpoints/stations.ts
var Stations = class extends BaseOrganizationEndpoints {
  getStation(stationId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("GET", `/stations/${stationId}`);
    });
  }
  stationForms(officeId, stationId) {
    return __async(this, null, function* () {
      const slug = this.getSlug();
      if (slug === null) {
        return {
          result: {
            elements: [],
            cursor: null
          },
          status: 200,
          ok: true,
          authError: false,
          error: false,
          originalBody: ""
        };
      }
      return this.requestWithStatus(
        "GET",
        `/organizations/${slug}/offices/${officeId}/stations/${stationId}/forms?include-pdfs=true`
      );
    });
  }
  hasStations() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/stations/available`
      );
    });
  }
  registerGuest(officeId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/offices/${officeId}/visits`,
        body
      );
    });
  }
  updateGuest(visitId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/stations/visits/${visitId}`,
        body
      );
    });
  }
  checkinGuest(stationId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/stations/${stationId}/visitors/presence`,
        body
      );
    });
  }
  guestCode(body) {
    return __async(this, null, function* () {
      return this.requestWithStatus("PUT", `/visits/code`, body);
    });
  }
  all(params) {
    return __async(this, null, function* () {
      const formatted = this.formatGenericParams(params);
      return this.requestWithStatus(
        "GET",
        `/stations?${formatted.toString()}`
      );
    });
  }
  stationVisits(params) {
    return __async(this, null, function* () {
      const formatted = this.formatGenericParams(params);
      return this.requestWithStatus(
        "GET",
        `/stations/visits?${formatted.toString()}`
      );
    });
  }
  getVisit(visitId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/stations/visits/${visitId}`
      );
    });
  }
  deleteStationVisit(visitId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/stations/visits/${visitId}`
      );
    });
  }
  update(stationId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/stations/${stationId}`,
        body
      );
    });
  }
  delete(stationId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/stations/${stationId}`
      );
    });
  }
};

// src/endpoints/teams.ts
var RESOLVE_PATH = {
  directory: ``,
  group: `/groups`,
  management: `/management`
};
var TeamsClient = class extends BaseOrganizationEndpoints {
  add(req) {
    return __async(this, null, function* () {
      const path = `/teams${RESOLVE_PATH[req.type]}`;
      return this.requestWithStatus("POST", path, req);
    });
  }
  delete(_0) {
    return __async(this, arguments, function* ({ id, type }) {
      const path = `/teams${RESOLVE_PATH[type]}/${encodeURIComponent(id)}`;
      return this.requestWithStatus("DELETE", path);
    });
  }
  update(id, type, body) {
    return __async(this, null, function* () {
      const path = `/teams${RESOLVE_PATH[type]}/${encodeURIComponent(id)}`;
      return yield this.requestWithStatus("PUT", path, body);
    });
  }
  all(_0) {
    return __async(this, arguments, function* ({
      type,
      query,
      hidden
    }) {
      const path = `/teams${RESOLVE_PATH[type]}`;
      const urlSearchParams = new URLSearchParams();
      if (hidden) {
        urlSearchParams.append("hidden", "1");
      }
      if (query) {
        urlSearchParams.append("query", query);
      }
      const queryString = urlSearchParams.toString();
      return this.requestWithStatus(
        "GET",
        path + (queryString ? `?${queryString}` : "")
      );
    });
  }
  members(_0) {
    return __async(this, arguments, function* ({
      id,
      query = null,
      type
    }) {
      const path = `/teams${RESOLVE_PATH[type]}/${encodeURIComponent(id)}/users`;
      const urlSearchParams = new URLSearchParams();
      if (query) {
        urlSearchParams.set("query", query);
      }
      const queryString = urlSearchParams.toString();
      return this.requestWithStatus(
        "GET",
        path + (queryString ? `?${queryString}` : "")
      );
    });
  }
  addMember(_0) {
    return __async(this, arguments, function* ({
      teamId,
      userId,
      type
    }) {
      const path = `/teams${RESOLVE_PATH[type]}/${encodeURIComponent(teamId)}/users/${encodeURIComponent(userId)}`;
      return this.requestWithStatus("POST", path);
    });
  }
  removeMember(_0) {
    return __async(this, arguments, function* ({
      teamId,
      userId,
      type
    }) {
      const path = `/teams${RESOLVE_PATH[type]}/${encodeURIComponent(teamId)}/users/${encodeURIComponent(userId)}`;
      return this.requestWithStatus("DELETE", path);
    });
  }
  forUser(_0) {
    return __async(this, arguments, function* ({
      userId,
      type
    }) {
      const path = `/users/${encodeURIComponent(userId)}/teams${RESOLVE_PATH[type]}`;
      return this.requestWithStatus("GET", path);
    });
  }
  managed() {
    return __async(this, arguments, function* ({ query } = {}) {
      const urlSearchParams = new URLSearchParams();
      if (query) {
        urlSearchParams.set("query", query);
      }
      const queryString = urlSearchParams.toString();
      return this.requestWithStatus(
        "GET",
        `/users/managed` + (queryString ? `?${queryString}` : "")
      );
    });
  }
  managedWithOptions(args) {
    return __async(this, null, function* () {
      const res = yield this.managed(args);
      if (res.ok && res.result) {
        const formatted = formatOptions(
          res.result
        );
        return __spreadProps(__spreadValues({}, res), { result: formatted });
      }
      return res;
    });
  }
};

// src/endpoints/unauthenticated.ts
var Unauthenticated = class extends BaseOrganizationEndpoints {
  stationAdd(otp, type) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", `/stations`, {
        code: otp,
        type
      });
    });
  }
  countries() {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/countries`
      );
    });
  }
};

// src/endpoints/uploads.ts
var Uploads = class extends BaseUserEndpoints {
};

// src/entities/user_settings.ts
var UserPropertyType = /* @__PURE__ */ ((UserPropertyType2) => {
  UserPropertyType2["DirectoryCustom"] = "directory_custom";
  UserPropertyType2["DirectoryRaw"] = "directory_raw";
  UserPropertyType2["LastUsersFilter"] = "last_users_filter";
  UserPropertyType2["LastTeamsFilter"] = "last_teams_filter";
  UserPropertyType2["LastOfficesFilter"] = "last_offices_filter";
  UserPropertyType2["DesignSystemVersion"] = "design_system_version";
  return UserPropertyType2;
})(UserPropertyType || {});

// src/endpoints/user_settings.ts
var UserSettings = class extends BaseOrganizationEndpoints {
  createOrUpdate(type, value) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", "/user/settings", {
        type,
        value
      });
    });
  }
  getByType(type) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/user/settings/${type}`
      );
    });
  }
  getAll() {
    return __async(this, null, function* () {
      return this.requestWithStatus("GET", "/user/settings");
    });
  }
  getDesignSystem() {
    return __async(this, null, function* () {
      const res = yield this.requestWithStatus(
        "GET",
        "/v1/settings/user"
      );
      const result = res.result;
      return result == null ? void 0 : result.settings.design_system_version;
    });
  }
  updateDesignSystem(value) {
    return __async(this, null, function* () {
      return this.requestWithStatus("PUT", "/v1/settings/user", {
        ["design_system_version" /* DesignSystemVersion */]: value
      });
    });
  }
};

// src/endpoints/users.ts
var Users = class extends BaseUserEndpoints {
  identity(authorization, userId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        `/identity`,
        { user: userId },
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  /**
   * Primary endpoint for returning the current authenticated user
   */
  me(options) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/user`,
        void 0,
        options
      );
    });
  }
  /**
   * Primary endpoint for returning the organizations to which an authenticated user belongs
   */
  organizations() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/organizations`
      );
    });
  }
  organizationAdd(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/organizations", body);
    });
  }
  organizationJoin(join) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/invitations/join/${encodeURIComponent(join)}`,
        {}
      );
    });
  }
  impersonate(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        `/users/${encodeURIComponent(body.email)}/impersonate`,
        {}
      );
    });
  }
};

// src/endpoints/wifi.ts
var Wifi = class extends BaseOrganizationEndpoints {
  /*
   * Returns all wifi connections in the organization
   */
  getWifiConnections() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        "/wifi_connections"
      );
    });
  }
  /*
   * Returns details for a single wifi connection in the organization
   */
  getWifiConnection(wifiConnectionId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/wifi_connections/${wifiConnectionId}`
      );
    });
  }
  /*
   * Updates an existing wifi connection in the organization
   */
  updateWifiConnection(wifiConnectionId, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/wifi_connections/${wifiConnectionId}`,
        body
      );
    });
  }
  /*
   * Creates a wifi connection in the organization
   */
  createWifiConnection(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        "/wifi_connections",
        body
      );
    });
  }
  /*
   * Deletes a wifi connection in the organization
   */
  deleteWifiConnection(wifiConnectionId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/wifi_connections/${wifiConnectionId}`
      );
    });
  }
  getVersions() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        "/downloads/wifi"
      );
    });
  }
};

// src/endpoints/tags.ts
var Tags = class extends BaseOrganizationEndpoints {
  getTags(filters) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/v1/tags${objectToFiltersQuery(filters)}`
      );
    });
  }
  getTag(pageFilters) {
    return __async(this, null, function* () {
      if (!pageFilters.id) throw new Error("Tag ID is required");
      return yield this.requestWithStatus(
        "GET",
        `/v1/tags/${pageFilters.id}`
      );
    });
  }
  createTag(tag) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", "/v1/tags", tag);
    });
  }
  updateTag(idTag, tag) {
    return __async(this, null, function* () {
      return this.requestWithStatus("PUT", `/v1/tags/${idTag}`, tag);
    });
  }
  deleteTag(idTag) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/v1/tags/${idTag}`
      );
    });
  }
  getCategories() {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        "/v1/tags/categories"
      );
    });
  }
  getResourceTags(idResource) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/v1/resources/${idResource}/tags`
      );
    });
  }
  addTagToResource(idResource, resourceTag) {
    return __async(this, null, function* () {
      if (Array.isArray(resourceTag)) {
        return this.requestWithStatus(
          "POST",
          `/v1/resources/${idResource}/tags/batch`,
          { tags: resourceTag }
        );
      }
      return this.requestWithStatus(
        "POST",
        `/v1/resources/${idResource}/tags`,
        resourceTag
      );
    });
  }
  updateResourceTag(idResource, idTag, resourceTag) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/v1/resources/${idResource}/tags/${idTag}`,
        resourceTag
      );
    });
  }
  deleteResourceTag(idResource, idTag) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/v1/resources/${idResource}/tags/${idTag}`
      );
    });
  }
  removeAllTagsFromResource(idResource) {
    return __async(this, null, function* () {
      var _a;
      const resourceTags = yield this.getResourceTags(idResource);
      const tags = (_a = resourceTags == null ? void 0 : resourceTags.result) == null ? void 0 : _a.tags;
      const tagIds = (tags == null ? void 0 : tags.map((tag) => tag.id)) || [];
      if (!tagIds.length) return;
      return this.requestWithStatus(
        "DELETE",
        `/v1/resources/${idResource}/tags/batch`,
        {
          resource_id: idResource,
          tag_ids: tagIds
        }
      );
    });
  }
};

// src/endpoints/agenda.ts
var AGENDA_BASE_PATH = "/v1/me/agenda";
var AgendaClient = class extends BaseSettingsEndpoints {
  getMyAgenda(_0) {
    return __async(this, arguments, function* ({
      from,
      to,
      tz
    }) {
      const fromParam = from ? `&start=${from}` : "";
      return this.get(`${AGENDA_BASE_PATH}?tz=${tz}${fromParam}`);
    });
  }
};

// src/endpoints/calendar-auth.ts
var CalendarAuth = class extends BaseOrganizationEndpoints {
  getAvailablePermissions(provider) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/v1/calendars/authorization/${provider}`
      );
    });
  }
  getMicrosoftPermissions() {
    return __async(this, null, function* () {
      return this.getAvailablePermissions("microsoft");
    });
  }
};

// src/endpoints/favorites.ts
var Favorites = class extends BaseOrganizationEndpoints {
  getFavorites(filters) {
    return __async(this, null, function* () {
      return this.requestWithStatus("GET", "/v1/me/favorites");
    });
  }
  addResourceFavorite(resourceId) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", "/v1/me/favorites", {
        target_id: resourceId,
        target_type: "resource"
      });
    });
  }
  deleteFavorite(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/v1/me/favorites/${id}`
      );
    });
  }
};

// src/endpoints/my-calendar.ts
var MY_CALENDAR_BASE_PATH = "/v1/me/calendar";
var MyCalendarClient = class extends BaseSettingsEndpoints {
  getCalendar(params) {
    return __async(this, null, function* () {
      const queryParams = {
        tz: params.tz
      };
      if (params.date) {
        queryParams.date = params.date;
      }
      if (params.user_id) {
        queryParams.user_id = params.user_id;
      }
      const url = this.addGenericParamsToUrl(MY_CALENDAR_BASE_PATH, queryParams);
      return this.get(url);
    });
  }
};

// src/client.ts
var Client = class {
  constructor(settings) {
    this.healthClient = null;
    this.leaveClient = null;
    this.activityClient = null;
    this.hoursClient = null;
    this.teamsClient = null;
    this.enterprisesClient = null;
    this.invitationsClient = null;
    this.integrationsClient = null;
    this.externalsClient = null;
    this.organizationsClient = null;
    this.reportsClient = null;
    this.formsClient = null;
    this.schedulesClient = null;
    this.divisionsClient = null;
    this.avigilonClient = null;
    this.coreIntegrationsClient = null;
    this.stationsClient = null;
    this.signupsClient = null;
    this.signaturesClient = null;
    this.wifiClient = null;
    this.usersClient = null;
    this.unauthenticatedClient = null;
    this.applicationClient = null;
    this.adminSchedulesClient = null;
    this.adminUsersClient = null;
    this.adminOrganizationsClient = null;
    this.adminLeaveClient = null;
    this.adminStationsClient = null;
    this.calendarClient = null;
    this.userSettingsClient = null;
    this.pagesClient = null;
    this.tagsClient = null;
    this.favoritesClient = null;
    this.uploadsClient = null;
    this.settingsClient = null;
    this.agendaClient = null;
    this.calendarAuthClient = null;
    this.myCalendarClient = null;
    var _a;
    this.settings = settings;
    this.slug = (_a = settings.slug) != null ? _a : "";
  }
  get enterprises() {
    if (this.enterprisesClient === null) {
      this.checkAccess();
      this.enterprisesClient = new Enterprises(this.settings, this.slug);
    }
    return this.enterprisesClient;
  }
  get invitations() {
    if (this.invitationsClient === null) {
      this.checkAccess();
      this.invitationsClient = new Invitations(this.settings, this.slug);
    }
    return this.invitationsClient;
  }
  get organizations() {
    if (this.organizationsClient === null) {
      this.checkAccess();
      this.organizationsClient = new Organizations(this.settings, this.slug);
    }
    return this.organizationsClient;
  }
  get adminOrganizations() {
    if (this.adminOrganizationsClient === null) {
      this.adminOrganizationsClient = new Organizations(this.settings, null);
    }
    return this.adminOrganizationsClient;
  }
  get pages() {
    if (this.pagesClient === null) {
      this.checkAccess();
      this.pagesClient = new Pages(this.settings, this.slug);
    }
    return this.pagesClient;
  }
  get tags() {
    if (this.tagsClient === null) {
      this.checkAccess();
      this.tagsClient = new Tags(this.settings, this.slug);
    }
    return this.tagsClient;
  }
  get favorites() {
    if (this.favoritesClient === null) {
      this.checkAccess();
      this.favoritesClient = new Favorites(this.settings, this.slug);
    }
    return this.favoritesClient;
  }
  get uploads() {
    if (this.uploadsClient === null) {
      this.checkAccess();
      this.uploadsClient = new Uploads(this.settings);
    }
    return this.uploadsClient;
  }
  get reports() {
    if (this.reportsClient === null) {
      this.checkAccess();
      this.reportsClient = new Reports(this.settings, this.slug);
    }
    return this.reportsClient;
  }
  get forms() {
    if (this.formsClient === null) {
      this.checkAccess();
      this.formsClient = new Forms(this.settings, this.slug);
    }
    return this.formsClient;
  }
  get integrations() {
    if (this.integrationsClient === null) {
      this.checkAccess();
      this.integrationsClient = new Integrations(this.settings, this.slug);
    }
    return this.integrationsClient;
  }
  get externals() {
    if (this.externalsClient === null) {
      this.checkAccess();
      this.externalsClient = new Externals(this.settings, this.slug);
    }
    return this.externalsClient;
  }
  get schedules() {
    if (this.schedulesClient === null) {
      this.checkAccess();
      this.schedulesClient = new Schedules(this.settings, this.slug);
    }
    return this.schedulesClient;
  }
  get stations() {
    if (this.stationsClient === null) {
      this.checkAccess();
      this.stationsClient = new Stations(this.settings, this.slug);
    }
    return this.stationsClient;
  }
  get adminStations() {
    if (this.adminStationsClient === null) {
      this.adminStationsClient = new Stations(this.settings, null);
    }
    return this.adminStationsClient;
  }
  get adminSchedules() {
    if (this.adminSchedulesClient === null) {
      this.adminSchedulesClient = new Schedules(this.settings, null);
    }
    return this.adminSchedulesClient;
  }
  get signatures() {
    if (this.signaturesClient === null) {
      this.checkAccess();
      this.signaturesClient = new Signatures(this.settings, this.slug);
    }
    return this.signaturesClient;
  }
  get signups() {
    if (this.signupsClient === null) {
      this.signupsClient = new Signups(this.settings);
    }
    return this.signupsClient;
  }
  get wifi() {
    if (this.wifiClient === null) {
      this.checkAccess();
      this.wifiClient = new Wifi(this.settings, this.slug);
    }
    return this.wifiClient;
  }
  get health() {
    if (this.healthClient === null) {
      this.checkAccess();
      this.healthClient = new Health(this.settings, this.slug);
    }
    return this.healthClient;
  }
  get leave() {
    if (this.leaveClient === null) {
      this.checkAccess();
      this.leaveClient = new LeaveClient(this.settings, this.slug);
    }
    return this.leaveClient;
  }
  get divisions() {
    if (this.divisionsClient === null) {
      this.checkAccess();
      this.divisionsClient = new DivisionsClient(this.settings, this.slug);
    }
    return this.divisionsClient;
  }
  get coreIntegrations() {
    if (this.coreIntegrationsClient === null) {
      this.checkAccess();
      this.coreIntegrationsClient = new CoreIntegrations(
        this.settings,
        this.slug
      );
    }
    return this.coreIntegrationsClient;
  }
  get avigilon() {
    if (this.avigilonClient === null) {
      this.checkAccess();
      this.avigilonClient = new AvigilonClient(this.settings, this.slug);
    }
    return this.avigilonClient;
  }
  get adminLeave() {
    if (this.adminLeaveClient === null) {
      this.adminLeaveClient = new LeaveClient(this.settings, null);
    }
    return this.adminLeaveClient;
  }
  get activity() {
    if (this.activityClient === null) {
      this.checkAccess();
      this.activityClient = new ActivityClient(this.settings, this.slug);
    }
    return this.activityClient;
  }
  get hours() {
    if (this.hoursClient === null) {
      this.checkAccess();
      this.hoursClient = new HoursClient(this.settings, this.slug);
    }
    return this.hoursClient;
  }
  get teams() {
    if (this.teamsClient === null) {
      this.checkAccess();
      this.teamsClient = new TeamsClient(this.settings, this.slug);
    }
    return this.teamsClient;
  }
  get users() {
    this.checkAccess(false);
    if (this.usersClient === null) {
      this.usersClient = new Users(this.settings);
    }
    return this.usersClient;
  }
  get adminUsers() {
    if (this.adminUsersClient === null) {
      this.adminUsersClient = new Users(this.settings);
    }
    return this.adminUsersClient;
  }
  get unauthenticated() {
    if (this.unauthenticatedClient === null) {
      this.unauthenticatedClient = new Unauthenticated(this.settings, null);
    }
    return this.unauthenticatedClient;
  }
  get application() {
    if (this.applicationClient === null) {
      this.checkAccess();
      this.applicationClient = new Application(this.settings, this.slug);
    }
    return this.applicationClient;
  }
  get calendar() {
    if (this.calendarClient === null) {
      this.calendarClient = new Calendar(this.settings, this.slug);
    }
    return this.calendarClient;
  }
  get calendarAuth() {
    if (this.calendarAuthClient === null) {
      this.calendarAuthClient = new CalendarAuth(this.settings, this.slug);
    }
    return this.calendarAuthClient;
  }
  get userSettings() {
    if (this.userSettingsClient === null) {
      this.userSettingsClient = new UserSettings(this.settings, this.slug);
    }
    return this.userSettingsClient;
  }
  checkAccess(withSlug = true) {
    if (withSlug && this.slug === null) {
      throw new Error("Missing slug");
    }
  }
  get orgOrOfficeSettings() {
    if (this.settingsClient === null) {
      this.settingsClient = new SettingsClient(this.settings, this.slug);
    }
    return this.settingsClient;
  }
  get agenda() {
    if (this.agendaClient === null) {
      this.agendaClient = new AgendaClient(this.settings, this.slug);
    }
    return this.agendaClient;
  }
  get myCalendar() {
    if (this.myCalendarClient === null) {
      this.myCalendarClient = new MyCalendarClient(this.settings, this.slug);
    }
    return this.myCalendarClient;
  }
};

// src/initApi.ts
var TacticApiClient = class _TacticApiClient {
  constructor(settings, embeddedSettings) {
    this.embeddedSettings = embeddedSettings;
    if (_TacticApiClient._instance) {
      throw new Error("Singleton cannot be instantiated more than once");
    }
    this.settings = settings;
    this.client = new Client(this.settings);
    this.user = null;
    _TacticApiClient._instance = this;
  }
  cookieExists() {
    return true;
  }
  setEmbeddedSettings() {
    this.settings = this.embeddedSettings;
    this.client = new Client(this.settings);
  }
  updateSlug(slug) {
    this.client = new Client(__spreadProps(__spreadValues({}, this.settings), { slug }));
  }
  updateUser(authenticatedUser) {
    this.user = authenticatedUser;
    if (!authenticatedUser.organization) {
      throw new Error("Organization is required");
    }
    const slug = authenticatedUser.organization.slug;
    this.client = new Client(__spreadProps(__spreadValues({}, this.settings), { slug }));
  }
  overrideConfig(settings, user) {
    this.settings = settings;
    this.client = new Client(this.settings);
    this.user = user;
  }
};
var initApi = (defaultSettings) => {
  const settings = __spreadValues({}, defaultSettings);
  if (settings.debugAuth && settings.debugAuthAccess) {
    settings.legacyAuth = {
      access: settings.debugAuthAccess,
      impersonation: null,
      idProvider: "Id"
    };
  }
  if (settings.unionDevAuth) {
    settings.authHeader = settings.unionDevAuth;
  }
  const embeddedSettings = {
    environment: settings.environment,
    slug: null,
    url: settings.url,
    debug: settings.debug,
    debugAuth: settings.debugAuth,
    debugGet: settings.debugGet,
    protocol: settings.protocol,
    domain: settings.domain,
    authHeader: settings.authHeader,
    corsBypass: settings.corsBypass,
    onError: (error, status) => {
      console.error("error handler:", error, status);
    }
  };
  const api = new TacticApiClient(settings, embeddedSettings);
  return { settings, embeddedSettings, api };
};

// src/defaults.ts
var DEFAULT_TACTIC_API_URL = "https://union.gettactic.com";
var DEFAULT_TACTIC_DEFAULT_PROTOCOL = "https";
var DEFAULT_TACTIC_DOMAIN_AND_PORT = "gettactic.com";
var DEFAULT_EXCLUDE_SENTRY_STATUS_CODES = [401, 403, 404];
var DEFAULT_TACTIC_AUTH_HEADER = "";

// src/entities/station.ts
var STATION_TYPE_VISITOR = "visitor";
var STATION_TYPE_ROOM = "room";

// src/entities/calendar.ts
var CalendarSource = /* @__PURE__ */ ((CalendarSource2) => {
  CalendarSource2["Google"] = "google";
  CalendarSource2["Microsoft"] = "microsoft";
  return CalendarSource2;
})(CalendarSource || {});
var CalendarType = /* @__PURE__ */ ((CalendarType2) => {
  CalendarType2["Resource"] = "resource";
  CalendarType2["User"] = "user";
  return CalendarType2;
})(CalendarType || {});

// src/integrations/google.ts
import { format as format5, parseISO as parseISO2 } from "date-fns";
import { utcToZonedTime as utcToZonedTime2, zonedTimeToUtc as zonedTimeToUtc2 } from "date-fns-tz";

// src/entities/visibility.ts
var VISIBILITY_PUBLIC = "public";
var VISIBILITY_PRIVATE = "private";
var VISIBILITY_CONFIDENTIAL = "confidential";

// src/integrations/google.ts
var _GoogleCalendarTransformer = class _GoogleCalendarTransformer {
  constructor() {
    this.settings = {
      removeNonHumanAttendees: true
    };
  }
  transform(calendarId, event, recurringEvent = null) {
    const scheduleRequest = this.createScheduleRequest(calendarId, event);
    const recurringScheduleRequest = recurringEvent ? this.createScheduleRequest(calendarId, recurringEvent) : null;
    if (recurringScheduleRequest !== null && recurringScheduleRequest.attendees.length === 0) {
      recurringScheduleRequest.attendees = [
        {
          email: scheduleRequest.organizer.email,
          name: scheduleRequest.organizer.name,
          presence_status: PRESENCE_STATUS_ACCEPTED,
          presence_type: null,
          user_id: null
        }
      ];
    }
    const request = {
      schedule: scheduleRequest,
      recurring_schedule: recurringScheduleRequest
    };
    return request;
  }
  transformBack(scheduleId, eventSource, calendar) {
    var _a, _b;
    const timeZone = eventSource.time_zone_id;
    const timeArgs = {
      start: {
        dateTime: eventSource.start_time ? _GoogleCalendarTransformer.getTimeWithoutZ(eventSource.start_time) : null,
        timeZone
      },
      end: {
        dateTime: eventSource.end_time ? _GoogleCalendarTransformer.getTimeWithoutZ(eventSource.end_time) : null,
        timeZone
      }
    };
    const participants = [];
    if (eventSource.attendees) {
      for (const attendee of eventSource.attendees) {
        participants.push({
          email: attendee.email,
          displayName: attendee.name,
          resource: false,
          responseStatus: _GoogleCalendarTransformer.PRESENCE_STATUS_MAP_REVERSED[attendee.presence_status]
        });
      }
    }
    if (eventSource.resource_attendees) {
      for (const attendee of eventSource.resource_attendees) {
        participants.push({
          email: attendee.email,
          displayName: attendee.name,
          resource: true,
          responseStatus: _GoogleCalendarTransformer.PRESENCE_STATUS_MAP_REVERSED[attendee.presence_status]
        });
      }
    }
    const metadata = _GoogleCalendarTransformer.generateMetadata(
      scheduleId,
      (_a = eventSource.calendar_event_integration_id) != null ? _a : null,
      calendar
    );
    const event = {
      summary: eventSource.title,
      location: eventSource.location,
      description: (_b = eventSource.description) != null ? _b : "",
      start: timeArgs.start,
      end: timeArgs.end,
      attendees: participants,
      reminders: {
        useDefault: true
        /*
            useDefault: false,
            overrides: [
              { method: 'email', 'minutes': 24 * 60 },
              { method: 'popup', 'minutes': 10 },
            ],
            */
      },
      transparency: "opaque",
      visibility: _GoogleCalendarTransformer.VISIBILITY_MAP_REVERSED[eventSource.visibility],
      extendedProperties: { private: metadata }
    };
    if (eventSource.recurring_rules !== null && eventSource.recurring_rules.length > 0) {
      event.recurrence = _GoogleCalendarTransformer.convertRRules(
        eventSource.recurring_rules,
        eventSource.recurring_end_time,
        timeZone
      );
    }
    return event;
  }
  createScheduleRequest(calendarId, event) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
    if (!event || !event.id || !event.start || !event.end || !event.creator || !event.creator.email) {
      throw new Error("Missing required event parameters");
    }
    const startTime = (_a = event.start.dateTime) != null ? _a : `${event.start.date}T00:00:00`, endTime = (_b = event.end.dateTime) != null ? _b : `${event.end.date}T00:00:00`, timeZone = (_c = event.start.timeZone) != null ? _c : "Etc/UTC";
    const creatorEmail = event.creator.email, creatorName = (_d = event.creator.displayName) != null ? _d : null, creatorIsNonHuman = creatorEmail.endsWith(
      _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_RESOURCE_EMAIL_SUFFIX
    ) || creatorEmail.endsWith(
      _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_GROUP_EMAIL_SUFFIX
    );
    const organizerEmail = event.organizer ? event.organizer.email : creatorEmail, organizerName = event.organizer ? event.organizer.displayName : creatorName, organizerIsNonHuman = organizerEmail.endsWith(
      _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_RESOURCE_EMAIL_SUFFIX
    ) || organizerEmail.endsWith(
      _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_GROUP_EMAIL_SUFFIX
    );
    const humanCreatorReplacesNonHumanOrganizer = this.settings.removeNonHumanAttendees && organizerIsNonHuman && !creatorIsNonHuman && creatorEmail != organizerEmail;
    let attendees = [];
    let attendeesByEmail = {};
    let resourceAttendees = [];
    for (const attendee of (_e = event.attendees) != null ? _e : []) {
      if (!attendee.email) {
        continue;
      }
      const attendeeEmail = attendee.email;
      const attendeeIsNonHumanResource = attendee.resource || attendeeEmail.endsWith(
        _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_RESOURCE_EMAIL_SUFFIX
      );
      if (attendeeIsNonHumanResource) {
        resourceAttendees.push({
          email: attendeeEmail,
          name: attendee.displayName ? attendee.displayName : null,
          presence_status: attendee.responseStatus ? _GoogleCalendarTransformer.PRESENCE_STATUS_MAP[attendee.responseStatus] : PRESENCE_STATUS_PENDING,
          presence_type: null,
          user_id: null
        });
      }
      if (this.settings.removeNonHumanAttendees && (attendeeIsNonHumanResource || attendeeEmail.endsWith(
        _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_GROUP_EMAIL_SUFFIX
      ))) {
        continue;
      }
      const attendeeRequest = {
        email: attendeeEmail,
        name: attendee.displayName ? attendee.displayName : null,
        presence_status: attendee.responseStatus ? _GoogleCalendarTransformer.PRESENCE_STATUS_MAP[attendee.responseStatus] : PRESENCE_STATUS_PENDING,
        presence_type: null,
        user_id: null
      };
      attendees.push(attendeeRequest);
      attendeesByEmail[attendeeRequest.email] = attendeeRequest;
    }
    if (attendees.length === 0) {
      if (humanCreatorReplacesNonHumanOrganizer) {
        attendees.push({
          email: creatorEmail,
          name: creatorName != null ? creatorName : null,
          presence_status: PRESENCE_STATUS_ACCEPTED,
          presence_type: null,
          user_id: null
        });
      } else if (!organizerEmail.endsWith(
        _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_GROUP_EMAIL_SUFFIX
      ) && !organizerEmail.endsWith(
        _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_RESOURCE_EMAIL_SUFFIX
      )) {
        attendees.push({
          email: organizerEmail,
          name: organizerName != null ? organizerName : null,
          presence_status: PRESENCE_STATUS_ACCEPTED,
          presence_type: null,
          user_id: null
        });
      }
    }
    const scheduleId = _GoogleCalendarTransformer.tryGetScheduleId(
      calendarId,
      event
    );
    const scheduleRequest = {
      creator: (_f = attendeesByEmail[creatorEmail]) != null ? _f : {
        email: creatorEmail,
        name: creatorName != null ? creatorName : null,
        presence_status: null,
        presence_type: null,
        user_id: null
      },
      organizer: (_h = attendeesByEmail[humanCreatorReplacesNonHumanOrganizer ? creatorEmail : organizerEmail]) != null ? _h : {
        email: humanCreatorReplacesNonHumanOrganizer ? creatorEmail : organizerEmail,
        name: (_g = humanCreatorReplacesNonHumanOrganizer ? creatorName : organizerName) != null ? _g : null,
        presence_status: null,
        presence_type: null,
        user_id: null
      },
      attendees,
      start: _GoogleCalendarTransformer.convertGoogleTimeToTacticTime(
        startTime,
        timeZone
      ),
      original_start: event.originalStartTime && event.originalStartTime.dateTime ? _GoogleCalendarTransformer.convertGoogleTimeToTacticTime(
        event.originalStartTime.dateTime,
        timeZone
      ) : null,
      end: _GoogleCalendarTransformer.convertGoogleTimeToTacticTime(
        endTime,
        timeZone
      ),
      time_zone: timeZone,
      recurring: event.recurrence ? this.convertRRulesToRecurringTask(event) : null,
      title: (_i = event.summary) != null ? _i : null,
      description: (_j = event.description) != null ? _j : null,
      visibility: event.visibility ? _GoogleCalendarTransformer.VISIBILITY_MAP[event.visibility] : VISIBILITY_PUBLIC,
      integration: {
        schedule_id: !!scheduleId ? scheduleId : null,
        event_id: event.id,
        event_updated: event.updated,
        ical_id: event.iCalUID,
        url: (_k = event.htmlLink) != null ? _k : null,
        event,
        is_deleted: event.status === "cancelled",
        resource_attendees: resourceAttendees.length > 0 ? resourceAttendees : null
      }
    };
    return scheduleRequest;
  }
  static generateMetadata(scheduleId, eventId, calendar) {
    const metadata = { tacticEventId: eventId }, metadataCalendarId = calendar.id.replace(/\-/g, "_"), scheduleKey = `tactic_schedule_${metadataCalendarId}`;
    metadata["tacticEventId"] = eventId != null ? eventId : void 0;
    metadata["tacticScheduleId"] = scheduleId;
    metadata[scheduleKey] = scheduleId;
    return metadata;
  }
  static tryGetScheduleId(calendarId, event) {
    const metadata = !!event.extendedProperties && !!event.extendedProperties.private ? event.extendedProperties.private : null;
    if (metadata === null) {
      return null;
    }
    const metadataCalendarId = calendarId.replace(/\-/g, "_"), scheduleKey = `tactic_schedule_${metadataCalendarId}`;
    return scheduleKey in metadata ? metadata[scheduleKey] : "tacticScheduleId" in metadata ? metadata["tacticScheduleId"] : "scheduleId" in metadata ? metadata["scheduleId"] : null;
  }
  static tryGetEventId(calendarId, event) {
    const eventId = !!event.extendedProperties && !!event.extendedProperties.private ? event.extendedProperties.private["tacticEventId"] : null;
    return eventId;
  }
  // Taken from integrations@google-client.ts
  static convertGoogleTimeToTacticTime(time, timeZone) {
    if (!time.includes("T")) {
      return `${time}T00:00:00Z`;
    }
    const date = parseISO2(time);
    if (!timeZone) {
      return date.toISOString().split(".")[0] + "Z";
    }
    const utcDate = new Date(date.toUTCString());
    const zonedTime = utcToZonedTime2(utcDate, timeZone);
    return format5(zonedTime, "yyyy-MM-dd'T'HH:mm:ss'Z'");
  }
  // Inspired from integrations@google-client.ts
  convertRRulesToRecurringTask(event) {
    var _a, _b;
    const parsedRules = event.recurrence.reduce(
      (acc, rule) => {
        const splitRule = rule.split("RRULE:");
        if (splitRule.length > 1) {
          acc.push(splitRule[1]);
        }
        return acc;
      },
      []
    );
    const timeZone = (_a = event.start.timeZone) != null ? _a : "Etc/UTC";
    let start = event.originalStartTime && event.originalStartTime.dateTime ? event.originalStartTime.dateTime : (_b = event.start.dateTime) != null ? _b : `${event.start.date}T00:00:00`;
    let end = null;
    if (parsedRules.length > 0) {
      const match = parsedRules[0].match(/UNTIL=([^;]+)/);
      const until = match ? match[1] : null;
      if (until) {
        const parsedTime = parseISO2(until);
        const utcTime = utcToZonedTime2(parsedTime, "UTC");
        const startUtc = parseISO2(start);
        if (startUtc >= parsedTime && event.created) {
          start = format5(
            utcToZonedTime2(parseISO2(event.created), "UTC"),
            "yyyy-MM-dd'T'HH:mm:ss'Z'"
          );
        }
        end = format5(utcTime, "yyyy-MM-dd'T'HH:mm:ss'Z'");
      }
    }
    return {
      rrules: parsedRules,
      start: _GoogleCalendarTransformer.convertGoogleTimeToTacticTime(
        start,
        "UTC"
      ),
      end: end !== null ? _GoogleCalendarTransformer.convertGoogleTimeToTacticTime(end, "UTC") : null
    };
  }
  static getTimeWithoutZ(date) {
    return date.charAt(date.length - 1) === "Z" ? date.slice(0, -1) : date;
  }
  static convertRRules(rrules, end, timeZoneId) {
    let rules = rrules.map((rule) => "RRULE:" + rule);
    if (end !== null) {
      if (end.endsWith("Z")) {
        end = end.slice(0, -1);
        end = end.replace("T", " ");
      }
      const utcEnd = zonedTimeToUtc2(end, timeZoneId);
      rules = rules.map(
        (rule) => `${rule};UNTIL=${format5(utcEnd, "yyyyMMdd'T'HHmmss'Z'")}`
      );
    }
    return rules;
  }
};
_GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_RESOURCE_EMAIL_SUFFIX = "@resource.calendar.google.com";
_GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_GROUP_EMAIL_SUFFIX = "@group.calendar.google.com";
_GoogleCalendarTransformer.PRESENCE_STATUS_MAP = {
  needsAction: PRESENCE_STATUS_PENDING,
  declined: PRESENCE_STATUS_REJECTED,
  tentative: PRESENCE_STATUS_ACCEPTED,
  accepted: PRESENCE_STATUS_ACCEPTED
};
_GoogleCalendarTransformer.PRESENCE_STATUS_MAP_REVERSED = {
  pending: "needsAction",
  rejected: "declined",
  accepted: "accepted"
};
_GoogleCalendarTransformer.VISIBILITY_MAP = {
  confidential: VISIBILITY_CONFIDENTIAL,
  default: VISIBILITY_PUBLIC,
  public: VISIBILITY_PUBLIC,
  private: VISIBILITY_PRIVATE
};
_GoogleCalendarTransformer.VISIBILITY_MAP_REVERSED = {
  confidential: "confidential",
  public: "public",
  private: "private"
};
var GoogleCalendarTransformer = _GoogleCalendarTransformer;

// src/integrations/microsoft.ts
import { parseISO as parseISO3 } from "date-fns";
import { findIana, findWindows } from "windows-iana";
var _MicrosoftCalendarTransformer = class _MicrosoftCalendarTransformer {
  constructor() {
    this.settings = {
      removeNonHumanAttendees: true
    };
  }
  transform(calendarId, event, recurringEvent = null) {
    let instanceEvent = null;
    if (recurringEvent !== null && event.id && event.seriesMasterId && event.type && "occurrence" === event.type && event.start && event.end && !("lastModifiedDateTime" in event)) {
      instanceEvent = __spreadValues(__spreadValues(__spreadValues({}, recurringEvent), { recurrence: null }), event);
    }
    const scheduleRequest = this.createScheduleRequest(
      calendarId,
      instanceEvent !== null ? instanceEvent : event,
      instanceEvent !== null ? event : null
    );
    let recurringScheduleRequest = recurringEvent ? this.createScheduleRequest(calendarId, recurringEvent, null) : null;
    if (recurringScheduleRequest !== null && recurringScheduleRequest.recurring === null) {
      recurringScheduleRequest = null;
    }
    if (recurringScheduleRequest !== null && recurringScheduleRequest.attendees.length === 0) {
      recurringScheduleRequest.attendees = [
        {
          email: scheduleRequest.organizer.email,
          name: scheduleRequest.organizer.name,
          presence_status: PRESENCE_STATUS_ACCEPTED,
          presence_type: null,
          user_id: null
        }
      ];
    }
    const request = {
      schedule: scheduleRequest,
      recurring_schedule: recurringScheduleRequest
    };
    return request;
  }
  transformBack(scheduleId, eventSource, calendar) {
    var _a;
    const start = _MicrosoftCalendarTransformer.getTimeWithoutZ(
      eventSource.start_time
    );
    const end = _MicrosoftCalendarTransformer.getTimeWithoutZ(
      eventSource.end_time
    );
    const timeZoneResult = _MicrosoftCalendarTransformer.convertTimeZone(
      eventSource.time_zone_id
    );
    if (timeZoneResult === null) {
      throw new Error(
        `Error while converting timezone ${eventSource.time_zone_id} to Microsoft's timezone`
      );
    }
    const timeZone = timeZoneResult[0];
    const participants = [];
    if (eventSource.attendees) {
      for (const attendee of eventSource.attendees) {
        participants.push({
          emailAddress: {
            name: attendee.name,
            address: attendee.email
          },
          status: {
            response: _MicrosoftCalendarTransformer.PRESENCE_STATUS_MAP_REVERSED[attendee.presence_status]
          }
        });
      }
    }
    if (eventSource.resource_attendees) {
      for (const attendee of eventSource.resource_attendees) {
        participants.push({
          emailAddress: {
            name: attendee.name,
            address: attendee.email
          },
          status: {
            response: _MicrosoftCalendarTransformer.PRESENCE_STATUS_MAP_REVERSED[attendee.presence_status]
          }
        });
      }
    }
    const eventId = eventSource.calendar_event_integration_id;
    const event = {
      start: {
        dateTime: start,
        timeZone
      },
      end: {
        dateTime: end,
        timeZone
      },
      organizer: {
        emailAddress: {
          name: eventSource.organizers[0].name,
          address: eventSource.organizers[0].email
        }
      },
      attendees: participants,
      sensitivity: _MicrosoftCalendarTransformer.VISIBILITY_MAP_REVERSED[eventSource.visibility],
      subject: eventSource.title,
      body: {
        contentType: "html",
        content: (_a = eventSource.description) != null ? _a : ""
      },
      location: {
        displayName: eventSource.location
      },
      showAs: "busy",
      responseRequested: false,
      isOrganizer: false,
      isAllDay: false,
      extensions: [
        _MicrosoftCalendarTransformer.generateMetadata(
          scheduleId,
          eventId,
          calendar
        )
      ]
    };
    return event;
  }
  transformRemovedOOO(event) {
    var _a, _b, _c;
    const policyType = "remote";
    const isDeleted = "@removed" in event;
    return {
      use: {
        policy_type: policyType,
        starts: (/* @__PURE__ */ new Date()).toISOString(),
        ends: (/* @__PURE__ */ new Date()).toISOString(),
        time_zone_id: "UTC",
        reason: (_a = event == null ? void 0 : event.subject) != null ? _a : null
      },
      integration: {
        event_id: event.id,
        event_updated: (/* @__PURE__ */ new Date()).toISOString(),
        ical_id: (_b = event.iCalUId) != null ? _b : event.id,
        url: (_c = event == null ? void 0 : event.webLink) != null ? _c : "removed-event",
        event,
        is_deleted: isDeleted
      }
    };
  }
  transformOOO(event) {
    var _a, _b, _c, _d, _e;
    if (!event.showAs || !_MicrosoftCalendarTransformer.SHOW_AS_OOOs.includes(event.showAs) || !event.start || !event.start.dateTime || !event.start.timeZone || event.start.timeZone !== "UTC" || !event.end || !event.end.dateTime || !event.end.timeZone || event.end.timeZone !== "UTC") {
      return null;
    }
    const lengthMinutes = (parseISO3(event.end.dateTime).getTime() - parseISO3(event.start.dateTime).getTime()) / (60 * 1e3);
    if (lengthMinutes < _MicrosoftCalendarTransformer.MINIMUM_OOO_EVENT_LENGTH_MINUTES) {
      return null;
    }
    if (event.showAs === "workingElsewhere" && !_MicrosoftCalendarTransformer.WORKING_ELSEWHERE_POLICY_TYPE_ENABLED.includes(((_a = event.subject) != null ? _a : "").trim().toLowerCase())) {
      return null;
    }
    const policyType = _MicrosoftCalendarTransformer.convertLeavePolicyType(
      (_b = event.categories) != null ? _b : [],
      (_c = event.subject) != null ? _c : null
    );
    if (policyType === null) {
      return null;
    }
    const isDeleted = "@removed" in event, startTimeUtc = _MicrosoftCalendarTransformer.convertMicrosoftTimeToTacticTime(
      event.start.dateTime
    ), endTimeUtc = _MicrosoftCalendarTransformer.convertMicrosoftTimeToTacticTime(
      event.end.dateTime
    );
    const leaveRequest = {
      use: {
        policy_type: policyType,
        starts: startTimeUtc,
        ends: endTimeUtc,
        time_zone_id: "UTC",
        reason: (_d = event.subject) != null ? _d : null
      },
      integration: {
        event_id: event.id,
        event_updated: _MicrosoftCalendarTransformer.convertMicrosoftTimeToTacticTime(
          event.lastModifiedDateTime
        ),
        ical_id: (_e = event.iCalUId) != null ? _e : event.id,
        // @TODO iCalUId is not defined in Event
        url: event.webLink,
        event,
        is_deleted: isDeleted
      }
    };
    return leaveRequest;
  }
  static generateMetadata(scheduleId, eventId, calendar) {
    const metadata = { tacticEventId: eventId }, metadataCalendarId = calendar.id.replace(/\-/g, "_"), scheduleKey = `tactic_schedule_${metadataCalendarId}`;
    metadata["tacticEventId"] = eventId != null ? eventId : "";
    metadata["tacticScheduleId"] = scheduleId;
    metadata[scheduleKey] = scheduleId;
    return __spreadValues({
      "@odata.type": "microsoft.graph.openTypeExtension",
      extensionName: _MicrosoftCalendarTransformer.EXTENSION_NAME
    }, metadata);
  }
  static tryGetScheduleId(calendarId, event) {
    const metadata = _MicrosoftCalendarTransformer.tryGetMetadata(event);
    if (metadata === null) {
      return null;
    }
    const metadataCalendarId = calendarId.replace(/\-/g, "_"), scheduleKey = `tactic_schedule_${metadataCalendarId}`;
    return scheduleKey in metadata ? metadata[scheduleKey] : "tacticScheduleId" in metadata ? metadata["tacticScheduleId"] : "scheduleId" in metadata ? metadata["scheduleId"] : null;
  }
  static tryGetEventId(calendarId, event) {
    const metadata = _MicrosoftCalendarTransformer.tryGetMetadata(event);
    return metadata !== null && "tacticEventId" in metadata ? metadata["tacticEventId"] : null;
  }
  static tryGetMetadata(event) {
    if (!!event.extensions && event.extensions.length > 0) {
      for (let i = 0, limiti = event.extensions.length; i < limiti; i++) {
        const extension = event.extensions[i];
        if (
          // @ts-expect-error Not defined in typescript type, but valid, see https://learn.microsoft.com/en-us/graph/api/opentypeextension-post-opentypeextension
          extension.extensionName === _MicrosoftCalendarTransformer.EXTENSION_NAME
        ) {
          const metadata = {};
          for (const key in extension) {
            if (key !== "extensionName" && key !== "@odata.type") {
              metadata[key] = extension[key];
            }
          }
          return metadata;
        }
      }
    }
    return null;
  }
  createScheduleRequest(calendarId, event, originalEvent) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    if (!event || !event.id || !event.start || !event.start.dateTime || !event.end || !event.end.dateTime || !event.organizer || !event.organizer.emailAddress || !event.organizer.emailAddress.address) {
      throw new Error("Missing required event parameters");
    }
    const organizerEmail = event.organizer.emailAddress.address.toLowerCase(), organizerName = (_a = event.organizer.emailAddress.name) != null ? _a : null;
    const attendees = [], humanAttendees = [];
    const attendeesByEmail = {};
    const resourceAttendees = [];
    let organizerIsNonHuman = false;
    for (const attendee of (_b = event.attendees) != null ? _b : []) {
      if (!attendee.emailAddress || !attendee.emailAddress.address || attendee.emailAddress.address.indexOf("@") === -1) {
        continue;
      }
      const attendeeEmail = attendee.emailAddress.address.toLowerCase(), attendeeName = (_c = attendee.emailAddress.name) != null ? _c : null;
      const attendeeIsNonHumanResource = "resource" === attendee.type || calendarId === attendeeEmail;
      if (attendeeIsNonHumanResource) {
        resourceAttendees.push({
          email: attendeeEmail,
          name: attendeeName,
          presence_status: PRESENCE_STATUS_ACCEPTED,
          presence_type: null,
          user_id: null
        });
      }
      if (attendeeIsNonHumanResource && organizerEmail === attendeeEmail) {
        organizerIsNonHuman = true;
      }
      if (this.settings.removeNonHumanAttendees && attendeeIsNonHumanResource) {
        continue;
      }
      const attendeeRequest = {
        email: attendeeEmail,
        name: attendeeName,
        presence_status: attendee.status && attendee.status.response ? _MicrosoftCalendarTransformer.PRESENCE_STATUS_MAP[attendee.status.response] : PRESENCE_STATUS_PENDING,
        presence_type: null,
        user_id: null
      };
      attendees.push(attendeeRequest);
      if (!attendeeIsNonHumanResource) {
        humanAttendees.push(attendeeRequest);
      }
      attendeesByEmail[attendeeRequest.email] = attendeeRequest;
    }
    if (resourceAttendees.length === 0 && !!event.locations && event.locations.length > 0) {
      for (const location of event.locations) {
        if (!!location.uniqueId && location.uniqueId.indexOf("@") >= 0 && !!location.locationType && location.locationType === "conferenceRoom") {
          resourceAttendees.push({
            email: location.uniqueId.toLowerCase(),
            name: !!location.displayName ? location.displayName : location.uniqueId,
            presence_status: PRESENCE_STATUS_ACCEPTED,
            presence_type: null,
            user_id: null
          });
        }
      }
    }
    if (!organizerIsNonHuman && organizerEmail.indexOf("@") === -1) {
      organizerIsNonHuman = true;
    }
    if (organizerIsNonHuman && humanAttendees.length === 0) {
      return null;
    }
    if (attendees.length === 0) {
      if (!organizerIsNonHuman) {
        attendeesByEmail[organizerEmail] = {
          email: organizerEmail,
          name: organizerName != null ? organizerName : null,
          presence_status: PRESENCE_STATUS_ACCEPTED,
          presence_type: null,
          user_id: null
        };
        attendees.push(attendeesByEmail[organizerEmail]);
      } else if (humanAttendees.length > 0) {
        attendees.push(humanAttendees[0]);
      }
    }
    const humanOrganizerEmail = organizerIsNonHuman ? humanAttendees[0].email : organizerEmail;
    if (!attendeesByEmail[humanOrganizerEmail]) {
      attendeesByEmail[humanOrganizerEmail] = {
        email: humanOrganizerEmail,
        name: null,
        presence_status: PRESENCE_STATUS_ACCEPTED,
        presence_type: null,
        user_id: null
      };
    }
    const startTime = _MicrosoftCalendarTransformer.convertMicrosoftTimeToTacticTime(
      event.start.dateTime
    ), endTime = _MicrosoftCalendarTransformer.convertMicrosoftTimeToTacticTime(
      event.end.dateTime
    ), timeZone = findIana(event.start.timeZone)[0];
    const isDeleted = "@removed" in event, recurringTask = event.recurrence ? _MicrosoftCalendarTransformer.convertPatternToRecurringTask(
      event.recurrence,
      timeZone,
      endTime
    ) : null;
    const scheduleId = _MicrosoftCalendarTransformer.tryGetScheduleId(
      calendarId,
      event
    );
    const scheduleRequest = {
      creator: attendeesByEmail[humanOrganizerEmail],
      organizer: attendeesByEmail[humanOrganizerEmail],
      attendees,
      start: startTime,
      original_start: startTime,
      end: endTime,
      time_zone: timeZone,
      recurring: recurringTask,
      title: (_d = event.subject) != null ? _d : null,
      description: (_f = (_e = event.body) == null ? void 0 : _e.content.trim()) != null ? _f : null,
      visibility: event.sensitivity ? _MicrosoftCalendarTransformer.VISIBILITY_MAP[event.sensitivity] : VISIBILITY_PUBLIC,
      integration: {
        schedule_id: scheduleId,
        event_id: event.id,
        event_updated: _MicrosoftCalendarTransformer.convertMicrosoftTimeToTacticTime(
          event.lastModifiedDateTime
        ),
        ical_id: null !== originalEvent ? (_g = originalEvent.iCalUId) != null ? _g : originalEvent.id : (_h = event.iCalUId) != null ? _h : event.id,
        // @TODO iCalUId is not defined in Event
        url: (_i = event.webLink) != null ? _i : null,
        event: originalEvent !== null ? originalEvent : event,
        is_deleted: isDeleted,
        resource_attendees: resourceAttendees
      }
    };
    return scheduleRequest;
  }
  static convertLeavePolicyType(categories, subject) {
    if (categories.length === 0 && (subject === null || subject.trim() === "")) {
      return null;
    }
    const subjectLower = subject !== null ? subject.trim().toLowerCase() : null;
    let leavePolicyType = null;
    if (subjectLower !== null && subjectLower in _MicrosoftCalendarTransformer.LEAVE_POLICY_TYPE_MAP) {
      leavePolicyType = _MicrosoftCalendarTransformer.LEAVE_POLICY_TYPE_MAP[subjectLower];
    } else if (categories.length > 0) {
      for (const category of categories) {
        const categoryLower = category.trim().toLowerCase();
        if (categoryLower in _MicrosoftCalendarTransformer.LEAVE_POLICY_TYPE_MAP) {
          leavePolicyType = _MicrosoftCalendarTransformer.LEAVE_POLICY_TYPE_MAP[categoryLower];
          break;
        }
      }
    } else {
      return "remote";
    }
    return leavePolicyType;
  }
  static convertMicrosoftTimeToTacticTime(time) {
    return time.substring(0, time.lastIndexOf(".")) + "Z";
  }
  static getTimeWithoutZ(date) {
    return date.charAt(date.length - 1) === "Z" ? date.slice(0, -1) : date;
  }
  static convertTimeZone(timeZoneId) {
    const timeZoneResult = findWindows(timeZoneId);
    if (timeZoneResult && timeZoneResult.length === 0) {
      return null;
    }
    return timeZoneResult;
  }
  /**
   * Converts a Microsoft recurrence pattern into an RRULE
   * Conversion based off of these pages:
   *     https://datatracker.ietf.org/doc/html/rfc5545
   *     https://github.com/microsoftgraph/microsoft-graph-docs/blob/main/concepts/outlook-schedule-recurring-events.md
   *     https://docs.microsoft.com/en-us/graph/api/resources/patternedrecurrence?view=graph-rest-1.0
   *
   * @param recurrence - Recurrence pattern from the Microsoft event
   * @returns An RRULE that contains the data specified in the recurrence pattern
   */
  static convertPatternToRecurringTask(recurrence, timeZone, scheduleEnd) {
    function convertDay(day) {
      return day.substring(0, 2).toUpperCase();
    }
    function convertDaysOfWeek(days, index) {
      return days.map((day) => `${index}${convertDay(day)}`).join(",");
    }
    if (recurrence == null || recurrence.pattern == null || !("type" in recurrence.pattern) || // Recurring with no occurrences
    !!recurrence.range && recurrence.range.numberOfOccurrences !== void 0 && !!recurrence.range.type && recurrence.range.type === "endDate" && !!recurrence.range.startDate && !!recurrence.range.endDate && recurrence.range.startDate === recurrence.range.endDate && recurrence.range.numberOfOccurrences === 0) {
      return null;
    }
    const rrule = {};
    switch (recurrence.pattern.type) {
      case "daily": {
        rrule["FREQ"] = "DAILY";
        rrule["INTERVAL"] = recurrence.pattern.interval;
        break;
      }
      case "weekly": {
        rrule["FREQ"] = "WEEKLY";
        rrule["INTERVAL"] = recurrence.pattern.interval;
        rrule["BYDAY"] = convertDaysOfWeek(recurrence.pattern.daysOfWeek, "");
        rrule["WKST"] = convertDay(recurrence.pattern.firstDayOfWeek);
        break;
      }
      case "absoluteMonthly": {
        rrule["FREQ"] = "MONTHLY";
        rrule["INTERVAL"] = recurrence.pattern.interval;
        rrule["BYMONTHDAY"] = recurrence.pattern.dayOfMonth;
        break;
      }
      case "relativeMonthly": {
        rrule["FREQ"] = "MONTHLY";
        rrule["INTERVAL"] = recurrence.pattern.interval;
        rrule["BYDAY"] = convertDaysOfWeek(
          recurrence.pattern.daysOfWeek,
          recurrence.pattern.index ? _MicrosoftCalendarTransformer.RRULE_SET_POS_MAP[recurrence.pattern.index] : ""
        );
        break;
      }
      case "absoluteYearly": {
        rrule["FREQ"] = "YEARLY";
        rrule["INTERVAL"] = recurrence.pattern.interval;
        rrule["BYMONTH"] = recurrence.pattern.month;
        rrule["BYMONTHDAY"] = recurrence.pattern.dayOfMonth;
        break;
      }
      case "relativeYearly": {
        rrule["FREQ"] = "YEARLY";
        rrule["INTERVAL"] = recurrence.pattern.interval;
        rrule["BYDAY"] = convertDaysOfWeek(
          recurrence.pattern.daysOfWeek,
          recurrence.pattern.index ? _MicrosoftCalendarTransformer.RRULE_SET_POS_MAP[recurrence.pattern.index] : ""
        );
        rrule["BYMONTH"] = recurrence.pattern.month;
        break;
      }
    }
    let recurrenceStart = null, recurrenceEnd = null;
    if (recurrence.range != null && "type" in recurrence.range) {
      switch (recurrence.range.type) {
        case "numbered": {
          rrule["COUNT"] = recurrence.range.numberOfOccurrences;
          break;
        }
        case "endDate": {
          const endTime = scheduleEnd.split("T")[1];
          rrule["UNTIL"] = `${recurrence.range.endDate.replace(/-/g, "")}T${endTime.replace(/:/g, "")}`;
          if (!!recurrence.range.startDate) {
            recurrenceStart = `${recurrence.range.startDate}T${endTime}`;
          }
          recurrenceEnd = `${recurrence.range.endDate}T${endTime}`;
          break;
        }
      }
    }
    const rruleString = [
      Object.keys(rrule).map((key) => `${key}=${rrule[key]}`).join(";")
    ];
    const task = { rrules: rruleString };
    if (recurrenceStart || recurrenceEnd) {
      task.start = recurrenceStart;
      task.end = recurrenceEnd;
      task.time_zone = timeZone;
    }
    return task;
  }
};
_MicrosoftCalendarTransformer.EXTENSION_NAME = "com.gettactic.calendar.sync";
_MicrosoftCalendarTransformer.SHOW_AS_OOOs = ["oof", "workingElsewhere"];
_MicrosoftCalendarTransformer.WORKING_ELSEWHERE_POLICY_TYPE_ENABLED = ["home office"];
_MicrosoftCalendarTransformer.MINIMUM_OOO_EVENT_LENGTH_MINUTES = 6 * 60;
_MicrosoftCalendarTransformer.LEAVE_POLICY_TYPE_MAP = {
  feiertag: "holiday",
  freizeit: "custom",
  holiday: "holiday",
  "home office": "remote",
  ooo: "ooo",
  "public holiday": "holiday",
  travel: "remote",
  urlaub: "vacation",
  vacation: "vacation"
};
_MicrosoftCalendarTransformer.PRESENCE_STATUS_MAP = {
  needsAction: PRESENCE_STATUS_PENDING,
  declined: PRESENCE_STATUS_REJECTED,
  organizer: PRESENCE_STATUS_ACCEPTED,
  tentative: PRESENCE_STATUS_ACCEPTED,
  tentativelyAccepted: PRESENCE_STATUS_ACCEPTED,
  accepted: PRESENCE_STATUS_ACCEPTED,
  notResponded: PRESENCE_STATUS_PENDING,
  none: PRESENCE_STATUS_ACCEPTED
};
_MicrosoftCalendarTransformer.PRESENCE_STATUS_MAP_REVERSED = {
  pending: "notResponded",
  rejected: "declined",
  accepted: "accepted"
};
_MicrosoftCalendarTransformer.VISIBILITY_MAP = {
  confidential: VISIBILITY_CONFIDENTIAL,
  default: VISIBILITY_PUBLIC,
  normal: VISIBILITY_PUBLIC,
  personal: VISIBILITY_PRIVATE,
  private: VISIBILITY_PRIVATE
};
_MicrosoftCalendarTransformer.VISIBILITY_MAP_REVERSED = {
  confidential: "confidential",
  public: "normal",
  private: "private"
};
_MicrosoftCalendarTransformer.RRULE_SET_POS_MAP = {
  first: "1",
  second: "2",
  third: "3",
  fourth: "4",
  last: "-1"
};
var MicrosoftCalendarTransformer = _MicrosoftCalendarTransformer;

// src/entities/user.ts
var UserRolesLabels = {
  owner: { label: "Admin", description: "" },
  member: { label: "Member", description: "" },
  scheduler: {
    label: "Scheduler",
    description: "Enables the user to create reservations on behalf of others"
  },
  resource_manager: {
    label: "Resource Manager",
    description: "Enable the user to manage workspaces in specific offices, floors, or zones"
  },
  team_manager: {
    label: "Team Manager",
    description: "Enable the user to manage other teams"
  },
  page_manager: {
    label: "Page Manager",
    description: "Enable the user to manage pages"
  }
};

// src/types/api-types.ts
var WL_PRESENCE_OFFICE = "office";
var WL_PRESENCE_REMOTE = "remote";
var WL_PRESENCE_OOO = "out_of_office";
var WL_NOT_AVAILABLE = "not_available";
var DATE_FORMAT_STYLE_YMD = "ymd";
var DATE_FORMAT_STYLE_DMY = "dmy";
var DATE_FORMAT_STYLE_MDY = "mdy";

// src/utils/resource-utils.ts
function isParking(res) {
  return ["parking_space", "parking_lot"].includes(res.type);
}

// src/utils/restriction-utils.ts
function sortRestrictions(restrictions, resId = null) {
  var _a, _b, _c;
  const weekDayRestrictions = [];
  const ruleRestrictions = /* @__PURE__ */ new Map();
  const officeHours = restrictions.filter(
    (x) => !!x.office_hour && x.error === "office_hours_not_available"
  );
  for (const day of ALL_WEEK_DAYS) {
    const dayRestriction = officeHours.find(
      (x) => {
        var _a2, _b2, _c2;
        return ((_a2 = x.office_hour) == null ? void 0 : _a2.type) === "weekday" && ((_c2 = (_b2 = x.office_hour) == null ? void 0 : _b2.days) == null ? void 0 : _c2.includes(day));
      }
    );
    if (dayRestriction) {
      weekDayRestrictions.push(dayRestriction);
    }
  }
  for (const restriction of officeHours) {
    if (((_a = restriction.office_hour) == null ? void 0 : _a.type) === "rule" && ((_b = restriction.office_hour) == null ? void 0 : _b.id)) {
      ruleRestrictions.set((_c = restriction.office_hour) == null ? void 0 : _c.id, restriction);
    }
  }
  return [
    ...weekDayRestrictions,
    ...Array.from(ruleRestrictions.values()),
    ...restrictions.filter(
      (x) => x.error !== "office_hours_not_available" && x.resource_id === resId
    )
  ];
}

// src/utils/schedule-utils.ts
function getScheduleResources(schedule) {
  const resourceMap = {};
  schedule.slots.forEach((slot) => {
    resourceMap[slot.resource.id] = slot.resource;
  });
  return resourceMap;
}

// src/entities/integrations/integration_type.ts
var IntegrationType = /* @__PURE__ */ ((IntegrationType2) => {
  IntegrationType2["GOOGLE"] = "google";
  IntegrationType2["GOOGLE_APP"] = "google-app";
  IntegrationType2["MICROSOFT"] = "microsoft";
  IntegrationType2["MICROSOFT_APP"] = "microsoft-app";
  IntegrationType2["ZOOM"] = "zoom";
  IntegrationType2["SLACK"] = "slack";
  IntegrationType2["MICROSOFT_TEAMS"] = "microsoft-teams";
  IntegrationType2["FRESHWATER"] = "freshwater";
  IntegrationType2["TACTIC_WIFI"] = "tactic-wifi";
  IntegrationType2["TACTIC_MOBILE"] = "tactic-mobile";
  return IntegrationType2;
})(IntegrationType || {});

// src/utils/datetime.ts
import { format as format6, parse, parseISO as parseISO4 } from "date-fns";
function cover24Hours(start, end) {
  return format6(start, "hh:mm aa") === "12:00 AM" && format6(end, "hh:mm aa") === "11:59 PM";
}
function parseTimeOnly(d) {
  return parse(d, "HH:mm:ss.SSS", /* @__PURE__ */ new Date());
}
function prettyTimeOnly(d) {
  return format6(parseTimeOnly(d), "hh:mm aa");
}
function parseDateOnlyString(date) {
  const localizeDate = date.replace("Z", "");
  return parseISO4(localizeDate);
}
function prettifyDateOnlyString(apiDate, showYear = false) {
  const parsed = parseDateOnlyString(apiDate);
  return format6(parsed, showYear ? "MMM d, yyyy" : "LLL d");
}
function prettifyDateOnlyStringTemplate(apiDate, template) {
  const parsed = parseDateOnlyString(apiDate);
  return format6(parsed, template);
}

// src/utils/defaultReservationTimeSettings.ts
var DEFAULT_TIME_SETTINGS = {
  start_hour: 9,
  start_minutes: 0,
  end_minutes: 0,
  end_hour: 17,
  meeting_room_duration: 1,
  desk_duration: 8
};

// src/index.ts
var V2_REDESIGN_FORCE_DATE = /* @__PURE__ */ new Date("2025-07-01");
export {
  ACTIVITY_ENTITIES,
  ACTIVITY_ENTITIES_ACTIONS,
  ALL_LEAVE_POLICY_TYPES,
  ALL_WEEK_DAYS,
  AVIGILON_REGIONS,
  ApiClientError,
  AvigilonClient,
  CORE_INTEGRATIONS_BASE_PATH,
  CalendarAuth,
  CalendarSource,
  CalendarType,
  Client,
  CoreIntegrationTypes,
  CoreIntegrations,
  DATE_FORMAT_STYLE_DMY,
  DATE_FORMAT_STYLE_MDY,
  DATE_FORMAT_STYLE_YMD,
  DEFAULT_EXCLUDE_SENTRY_STATUS_CODES,
  DEFAULT_TACTIC_API_URL,
  DEFAULT_TACTIC_AUTH_HEADER,
  DEFAULT_TACTIC_DEFAULT_PROTOCOL,
  DEFAULT_TACTIC_DOMAIN_AND_PORT,
  DEFAULT_TIME_SETTINGS,
  Enterprises,
  Externals,
  Forms,
  GoogleCalendarTransformer,
  IntegrationType,
  Integrations,
  Invitations,
  LeavePolicyTypeDisplay,
  MicrosoftCalendarTransformer,
  Organizations,
  PRESENCE_STATUS_ACCEPTED,
  PRESENCE_STATUS_PENDING,
  PRESENCE_STATUS_REJECTED,
  PRESENCE_TYPE_IN_PERSON,
  PRESENCE_TYPE_OOO,
  PRESENCE_TYPE_REMOTE,
  Pages,
  Reports,
  ResponseWithStatus,
  STATION_TYPE_ROOM,
  STATION_TYPE_VISITOR,
  Schedules,
  Signups,
  TacticApiClient,
  Uploads,
  UserPropertyType,
  UserRolesLabels,
  Users,
  V2_REDESIGN_FORCE_DATE,
  VISIBILITY_CONFIDENTIAL,
  VISIBILITY_PRIVATE,
  VISIBILITY_PUBLIC,
  WL_NOT_AVAILABLE,
  WL_PRESENCE_OFFICE,
  WL_PRESENCE_OOO,
  WL_PRESENCE_REMOTE,
  cover24Hours,
  formatOptions,
  getScheduleResources,
  initApi,
  isParking,
  parseDateOnlyString,
  parseTimeOnly,
  prettifyDateOnlyString,
  prettifyDateOnlyStringTemplate,
  prettyTimeOnly,
  sortRestrictions
};
//# sourceMappingURL=index.mjs.map